// All the fetches are in one file, so the whole thing can be easily mocked
import fetch from "cross-fetch";
import _ from "underscore";
import download from "downloadjs";
import moment from "moment";
import md5 from "md5";
import { Auth, Hub } from "aws-amplify"
// import xhr from "xhr";
// import { Storage } from 'aws-amplify';

import {
	ADD_DATA_EXPLORER_USER_CREATED_SEARCH,
	ADD_MEDIA_TIMESERIES,
	ADD_TRANSLATION_TO_TRANSCRIPTS,
	ADD_USER_CREATED_SEARCH,
	CLOSE_CREATE_SEARCH_MODAL,
	CLOSE_DATA_EXPLORER_DELETE_SEARCH_MODAL,
	CLOSE_DELETE_SEARCH_MODAL,
	CLOSE_DATA_EXPLORER_CREATE_SEARCH_MODAL,
	DELETE_DATA_EXPLORER_USER_CREATED_SEARCH,
	CONTENT_NAVIGATION,
	DATA_EXPLORER_SAVE_USER_SEARCH_ERROR,
	DATA_EXPLORER_SAVE_USER_SEARCH_SPINNER,
	DATA_EXPLORER_SAVE_USER_SEARCH_SUCCESS,
	ERROR_LOADING_TWEETS,
	FETCHING_DATA_EXPLORER_DYNAMIC_FILTERS,
	FETCHING_DATA_EXPLORER_PDF_DATA,
	FETCHING_MEDIA_ARTICLES,
	FETCHING_MEDIA_DYNAMIC_FILTERS,
	FETCHING_POST_COMMENTS,
	FETCHING_REPORTS,
	FETCHING_TWEETS,
	FILTER_CONTENT_BY_DATE,
	NO_POST_COMMENTS,
	PROACTIVELY_DELETE_USER_CREATED_SEARCH,
	RECEIVE_ALT_NARRATIVES_FOR_CROSSTABS,
	RECEIVE_ARTICLES_ERROR,
	RECEIVE_ARTICLES_RETRY,
	RECEIVE_PHRASES_LEFT,
	RECEIVE_PHRASES_RIGHT,
	RECEIVE_CONTENT_ENTITIES,
	RECEIVE_CROSSTABS_MAP_STATS,
	RECEIVE_CROSSTABS_STATS,
	RECEIVE_DATA_EXPLORER_DYNAMIC_FILTERS,
	RECEIVE_DATA_EXPLORER_DYNAMIC_FILTERS_ERROR,
	REQUEST_DATA_EXPLORER_ENTITIES,
	RECEIVE_DATA_EXPLORER_ENTITIES,
	RECEIVE_DATA_EXPLORER_ENTITIES_ERROR,
	RECEIVE_DATA_EXPLORER_ENTITIES_RETRY,
	RECEIVE_DATA_EXPLORER_FILTERS,
	RECEIVE_DATA_EXPLORER_PDF_DATA,
	RECEIVE_DATA_EXPLORER_PDF_DATA_ERROR,
	RECEIVE_DATA_EXPLORER_PDF_DATA_RETRY,
	RECEIVE_DATA_EXPLORER_SINGLE_ARTICLE,
	RECEIVE_MEDIA_ARTICLES,
	RECEIVE_MEDIA_ARTICLES_ERROR,
	RECEIVE_MEDIA_ARTICLES_RETRY,
	RECEIVE_MEDIA_DYNAMIC_FILTERS,
	RECEIVE_MEDIA_DYNAMIC_FILTERS_ERROR,
	RECEIVE_MEDIA_ENTITIES,
	RECEIVE_MEDIA_ENTITIES_ERROR,
	RECEIVE_MEDIA_ENTITIES_RETRY,
	RECEIVE_MEDIA_FILTERS,
	RECEIVE_MEDIA_TIMESERIES,
	RECEIVE_MEDIA_TIMESERIES_ERROR,
	RECEIVE_MEDIA_TIMESERIES_RETRY,
	RECEIVE_NARRATIVE_MODAL_BARGRAPH,
	RECEIVE_NARRATIVE_MODAL_TIMESERIES,
	RECEIVE_PHRASES,
	RECEIVE_POST_COMMENTS,
	RECEIVE_REPORTS,
	RECEIVE_SEARCH_LIST,
	RECEIVE_VIDEO_DATA,
	RECEIVE_TOPIC_STATS,
	RECEIVE_TWEETS,
	RECEIVE_USER_SEARCHES,
	RECEIVE_USER_SUBSCRIPTIONS,
	RECEIVE_VIDEO_ENTITIES,
	RECEIVE_VIDEO_FEED,
	RECEIVE_VIDEO_FILTERS,
	REQUEST_PHRASES,
	REQUEST_COMPARE_PHRASES_LEFT,
	REQUEST_COMPARE_PHRASES_RIGHT,
	RESET_DATA,
	SAVE_FILTER_SET_SPINNER,
	SAVE_USER_SEARCH_ERROR,
	SAVE_USER_SEARCH_SPINNER,
	SAVE_USER_SUCCESS,
	SET_DATA_EXPLORER_SEARCH,
	SET_MEDIA_ACTIVE_SEARCH,
	SET_PROJECT,
	SET_CURRENT_ZOOM,
	SETUP_TOPIC_STATS,
	SYNC_LANGUAGES,
	PROCESSING_INITIAL_TRENDS_REQUEST,
	RECEIVE_ENTITIES,
	RECEIVE_ENTITIES_ERROR,
	RECEIVE_ENTITIES_RETRY,
	MAP_DATA_LOADING,
	RECEIVE_MAP_DATA,
	RECEIVE_MAP_DATA_ERROR,
	RECEIVE_MAP_DATA_RETRY,
	UPDATE_DATA_EXPLORER_SEARCH_INPUT,
	UPDATE_MEDIA_SEARCH_INPUT,
} from "actions/constants.js";

import {
	ENTITY_VIEW_FETCH_ENTITY_DATA,
	ENTITY_VIEW_RECEIVE_ENTITY_DATA,
	ENTITY_VIEW_RECEIVE_ENTITY_DATA_ERROR,
	ENTITY_VIEW_RECEIVE_ENTITY_DATA_RETRY,
	ENTITY_VIEW_FETCH_EXPAND_GRAPH_DATA,
	ENTITY_VIEW_RECEIVE_EXPAND_GRAPH_DATA,
	ENTITY_VIEW_RECEIVE_EXPAND_GRAPH_DATA_ERROR,
	ENTITY_VIEW_RECEIVE_EXPAND_GRAPH_DATA_RETRY,
	ENTITY_VIEW_FETCH_GRAPH_DATA,
	ENTITY_VIEW_RECEIVE_GRAPH_DATA,
	ENTITY_VIEW_RECEIVE_GRAPH_DATA_ERROR,
	ENTITY_VIEW_RECEIVE_GRAPH_DATA_RETRY,
	ENTITY_VIEW_FETCH_MEDIA_MENTIONS,
	ENTITY_VIEW_RECEIVE_MEDIA_MENTIONS,
	ENTITY_VIEW_RECEIVE_MEDIA_MENTIONS_ERROR,
	ENTITY_VIEW_RECEIVE_MEDIA_MENTIONS_RETRY,
	ENTITY_VIEW_FETCH_TIME_SERIES,
	ENTITY_VIEW_RECEIVE_TIME_SERIES,
	ENTITY_VIEW_RECEIVE_TIME_SERIES_ERROR,
	ENTITY_VIEW_RECEIVE_TIME_SERIES_RETRY,
} from "actions/constants/entityViewActionTypes.js"

import { addOrRemoveString, cloneObjectWithout, langCodeLookup, mergeEntityFilters, trimSeries } from "@exo/helpers";
import { 
	DYNAMIC_FILTER_TYPE, 
	DYNAMIC_FILTER_RESULT_TYPE, 
	decorateFilters,
	addConfigFilters, 
	alignPerspectiveOnLocationFilters, 
	formatQueryAddsForPost,
	formatQueryExcludesForPost,
	formatFiltersForPost, 
	formatHierarchyFiltersForPost, 
	reactivateFilters 
} from "lib/helpers/filterHelpers.js";
import { describeFilters, determineSliceInDays, findCommonRange, formatFilters, isThisAnEvent, setStartDate } from "lib/helpers/helpers.js";
import { adjustStartDateForAggregation } from "lib/helpers/graphHelpers.js";
import { formatNarrativeBarGraph } from "lib/helpers/crosstabsHelpers.js";
import headerTypes from "lib/table/tableHeaders.js";
import { buildTableHeaders, allQuotesSingle, allQuotesDouble, allQuotesDoubleTemporary } from "lib/helpers/mediaHelpers.js";
import { assignStaticColor, colors } from "lib/helpers/helpers.js";

import { receiveTrends } from "actions/trends.js";
import { requestAnalysis, receiveAnalysis } from "actions/analysis.js";
import { receiveArticles } from "actions/articles.js";
import { updateData } from "actions/data.js";
import { receiveMapData } from "actions/map.js";
import { submitSupportTicketInit, supportTicketSubmitResponse } from "actions/support.js";
import {
	receiveMapDataCompare,
	receiveTimeseriesCompare,
	receiveCompareArticles,
	receiveCompareEntities,
	receiveCorrelation,
} from "actions/compare.js";
import {graphTransformer, graphExtendTransformer} from "layout/EntityView/transformers/graphTransformer.js";
import entityTransformer from "layout/EntityView/transformers/entityTransformer.js";

// import { receiveContentExport } from "actions/content.js";
// import { parseTranscript } from "lib/helpers/videoHelpers.js";

// import fakeMapData from "lib/mockData/afghanMap.js";
// import mockAPI from "lib/mockData/mockAPI.js";
// import mockCorrelation from "lib/mockData/mockCorrelation.js";
// import mockCreateResponse from "lib/mockData/mockCreateResponse.js";
// import mockSavedFilters from "lib/mockData/mockSavedFilters.js";
// import mockSavedSearches from "lib/mockData/mockSavedSearches.js";
// import mockSingleArticle from "lib/mockData/mockSingleArticle.js";
// import mockShareData from "lib/mockData/mockShareData.js";
import mockReports from "../../lib/mockData/mockReports";
// import { mockProcurement2 } from "../../lib/mockData/mockProcurement.js";
import { SYNC_COUNTRIES } from "../constants";
import { MAX_DYNAMIC_FILTERS } from "../../lib/helpers/filterHelpers";
// import mockTweets from "../../lib/mockData/mockTweets";
// import mockExpandedContent from "lib/mockData/mockExpandedContent.js";
// import mockCandidates from "lib/mockData/mockCandidates.js";

const SERVER_ERROR = "Bad response from server";
const FETCH_RETRY_MAX = 1;
const CONTENT_PAGE_LENGTH = 50;

function getRandomInt(min, max) {
	return Math.floor(Math.random() * (max - min + 1)) + min;
};

export function dispatchTokenFailure() {
	Hub.dispatch(
		'TokenFailureChannel', 
		{ 
			event: 'unauth', 
			data: null, 
			message:'Unauthorized' 
	});
}

export const randomUSCCKey = () => {
	const usccKeys = [
		"trumpKey",
		"taxKey",
		"dacaKey",
		"borderKey",
		"tradeKey",
		"texaspolKey",
		"hurdKey",
		"ortizKey",
		"cornynKey",
		"cruzKey",
		"betoKey",
		"abbottKey",
	];
	return usccKeys[getRandomInt(0, usccKeys.length - 1)];
};

// CognitoIdentityServiceProvider.4qn94eh0gheufak1vuqvtrhpap.Tyler.idToken
// This dispatches all the fetches needed to seed the app, with the default params
// Make sure it only gets called on load! Happens right after login
// NOTE: shareDataObject is only passed if loading as part of a share URL
export function fetchTrends(shareDataObject) {
	return (dispatch, getState) => {
		const { api, userData, userName, authToken } = getState().login;
		const staging = getState().base.stagingData;
		const { topicsPie } = getState().projectConfig;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);

		// Store record of initial trends request having been sent
		dispatch({ type: PROCESSING_INITIAL_TRENDS_REQUEST });
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		// if api.key is false, use a GET request
		if (api.key) {
			return fetch(`${api.narratives}?staging=${staging}`, {
				method: "POST",
				mode: "cors",
				body: JSON.stringify({
					MOE: true,
					project: api.key,
					userName,
					userPool,
					user: `${userName}_${userPool}`,
					// startDate: startDate ? startDate.toString() : null,
					// endDate: endDate ? endDate.toString() : null,,
					// slice: 15,
					// narrative,
					// perspective,
					// filters: formatFiltersForPost(filtersList),
				}),
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
					// 'Access-Control-Allow-Origin': '*',
				},
			})
				.then((response) => response.json())
				.then((json) => {			
					dispatch(
						receiveTrends({
							json,
							noInit: !!shareDataObject,
							sharedActiveNarrativeData: shareDataObject ? shareDataObject.activeNarrativeData : false,
						})
					);
					// Narrative tab share data fetch
					if (shareDataObject) {
						const {
							activeFilters,
							activeNarrativeData,
							entityFilters,
							contentFilteredByDate,
							currentZoom,
							keywords,
							mapHighlightId,
							perspective,
							relevancyOverride,
						} = shareDataObject;
						dispatch(
							updateData({
								activeFilters,
								contentFilteredByDate,
								entityFilters,
								currentZoom,
								keywords,
								mapHighlightId,
								nar: activeNarrativeData,
								perspective,
								relevancyOverride,
								topicsPie,
							})
						);
					}
				})
				.catch((error, json) => {
					console.log(json);
					console.error(error);
				});
		} else {
			api.optionsForGET["headers"]["authorization"] = idToken;
			return fetch(`${api.narratives}?staging=${staging}&userName=${userName}&userPool=${userPool}`, api.optionsForGET)
				.then((response) => response.json())
				.then((json) => dispatch(receiveTrends({ json, noInit: !!shareDataObject })))
				.catch((error, json) => {
					console.log(json);
					console.error(error);
				});
		}
	};
};

export function fetchAltNarrativesForCrosstabs(projectId) {
	// console.log('fetchTrends', shareDataObject);
	return (dispatch, getState) => {
		const { api, userData, userName, authToken } = getState().login;
		const staging = getState().base.stagingData;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		return fetch(`${api.narratives}?staging=${staging}`, {
			method: "POST",
			mode: "cors",
			body: JSON.stringify({
				MOE: true,
				project: projectId,
				userName,
				userPool,
				user: `${userName}_${userPool}`,
				// startDate: startDate ? startDate.toString() : null,
				// endDate: endDate ? endDate.toString() : null,,
				// slice: 15,
				// narrative,
				// perspective,
				// filters: formatFiltersForPost(filtersList),
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
				// 'Access-Control-Allow-Origin': '*',
			},
		})
			.then((response) => response.json())
			.then((json) => {
				const narratives = _.find(json, (data) => {
					return data.id === "narratives";
				});
				const flatNarratives = [narratives];
				_.each(narratives.children, (nar) => {
					flatNarratives.push(nar);
					_.each(nar.children, (childNar) => {
						flatNarratives.push(childNar);
					});
				});
				dispatch({
					type: RECEIVE_ALT_NARRATIVES_FOR_CROSSTABS,
					flatNarratives,
				});
			})
			.catch((error, json) => {
				console.log(json);
				console.error(error);
			});
	};
};

// ------------ Curated Tab -------------
// This dispatches the fetch for the content - returns all content
// Make sure it only gets called on load! Happens right after login
export const fetchContent = () => {
	return (dispatch, getState) => {
		dispatch({ type: "requestContent" });
		const { api, userData, userName, authToken } = getState().login;
		const { aiOnly } = getState().commonUI;
		const { dateStart, dateEnd } = getState().contentTab;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		return fetch(`${api.content}`, {
			method: "POST",
			mode: "cors",
			body: JSON.stringify({
				// ai: aiOnly, // No AI for content tab
				contentTab: true,
				endDate: dateEnd ? dateEnd.toString() : null,
				filters: [],
				perspective: "Source",
				// UNMOCK this
				project: api.key,
				// project: "e785c152058a28fac18d3f3e1a7088dc", // GEC
				showDuplicates: true,
				slice: 15,
				startDate: dateStart ? dateStart.toString() : null,
				user: `${userName}_${userPool}`,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
				// 'Access-Control-Allow-Origin': '*',
			},
		})
			.then((response) => response.json())
			.then((json) => dispatch({ type: "contentIsHere", articles: json }))
			.catch((error, json) => {
				console.log("fetchContent error", json);
				console.error("fetchContent error", error);
			});
	};
};

export const fetchContentFilters = (params) => {
	const { aiOverride } = params;

	return (dispatch, getState) => {
		const { api, userData, userName, authToken } = getState().login;
		const { aiOnly } = getState().commonUI;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(`${api.contentFilters}`, {
			method: "POST",
			mode: "cors",
			body: JSON.stringify({
				// TODO: UNMOCK this
				// project: 'e785c152058a28fac18d3f3e1a7088dc', // mock filters - GEC
				project: api.key,
				// ai: typeof aiOverride !== "undefined" ? aiOverride : aiOnly, // currently no AI for content tab
				contentTab: true,
				user: `${userName}_${userPool}`,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => response.json())
			.then((json) => dispatch({ type: "contentFiltersAreHere", filters: json }))
			.catch((error, json) => {
				console.log("fetchContentFilters error", json);
				console.error("fetchContentFilters error", error);
			});
	};
};

export const fetchContentEntities = (params) => {
	console.log("------ fetchContentEntities -------");
	// const { aiOverride } = params;
	return (dispatch, getState) => {
		const { api, userData, userName, authToken } = getState().login;
		const { analystSystem } = getState().projectConfig;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		// const { aiOnly } = getState().commonUI;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(`${api.contentEntities}`, {
			method: "POST",
			mode: "cors",
			body: JSON.stringify({
				// TODO: UNMOCK this
				// project: 'e785c152058a28fac18d3f3e1a7088dc', // mock filters - GEC
				project: api.key,
				// ai: typeof aiOverride !== "undefined" ? aiOverride : aiOnly, // currently no AI for content tab
				contentTab: true,
				user: `${userName}_${userPool}`,

				analystSystem,
				// endDate: fullEndDate,
				// event: isThisAnEvent({ id: narrativeId, events: getState().events.eventTypes }),
				filters: [], // filters: formatFiltersForPost(filtersList),
				// parent: narrative.parent,
				perspective: "Source",
				// narrative: narrativeId,
				// relevancy,
				slice: 15,
				// startDate,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
				// 'Access-Control-Allow-Origin': '*',
			},
		})
			.then((response) => response.json())
			.then((json) => dispatch({ type: RECEIVE_CONTENT_ENTITIES, entities: json }))
			.catch((error, json) => {
				console.log("fetchContentEntities error", json);
				console.error("fetchContentEntities error", error);
			});
	};
};

export const fetchContentArticles = (params) => {
	const { filters, dateStart, dateEnd, aiOverride, keywords, share, shareSingleArticleId } = params;
	const formattedFilters = formatFiltersForPost(filters);

	return (dispatch, getState) => {
		dispatch({ type: "requestContent" });
		dispatch({ type: "setContentTabDates", dateStart, dateEnd });
		const { api, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { aiOnly } = getState().commonUI;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(`${api.content}`, {
			method: "POST",
			mode: "cors",
			body: JSON.stringify({
				// ai: typeof aiOverride !== "undefined" ? aiOverride : aiOnly, // No AI for content tab
				contentTab: true,
				endDate: dateEnd ? dateEnd.toString() : null,
				filters: keywords && keywords.length > 0 ? [...formattedFilters, { keywords }] : formattedFilters,
				perspective: "Source",
				// UNMOCK this
				project: api.key,
				// project: "e785c152058a28fac18d3f3e1a7088dc", // GEC
				slice: 15,
				showDuplicates: true,
				startDate: dateStart ? dateStart.toString() : null,
				user: `${userName}_${userPool}`,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
				// 'Access-Control-Allow-Origin': '*',
			},
		})
			.then((response) => response.json())
			.then((json) => dispatch({ type: "contentIsHere", articles: json, filters, share, shareSingleArticleId }))
			.catch((error, json) => {
				console.log("fetchContent error", json);
				console.error("fetchContent error", error);
			});
	};
};

// ----------- Video Tab ----------
export const fetchVideoFilters = () => {
	return (dispatch, getState) => {
		const { api, userData, userName, authToken } = getState().login;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(`${api.videoFilters}`, {
			method: "POST",
			mode: "cors",
			body: JSON.stringify({
				// project: 'e785c152058a28fac18d3f3e1a7088dc', // mock filters - GEC
				project: api.key,
				videoTab: true,
				user: `${userName}_${userPool}`,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
				// 'Access-Control-Allow-Origin': '*',
			},
		})
			.then((response) => response.json())
			.then((json) => dispatch({ type: RECEIVE_VIDEO_FILTERS, filtersUI: formatFilters(json[0].children) }))
			.catch((error, json) => {
				console.error("RECEIVE_VIDEO_FILTERS error", error);
			});
	};
};

export const fetchVideoFeed = (params) => {
	const { endDate, startDate, fetchKey, filtersList, keywords } = params;

	return (dispatch, getState) => {
		const { api, userData, userName, authToken } = getState().login;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const filtersForAPI = formatFiltersForPost(filtersList);
		const filterWithKeywords = keywords && keywords.length > 0 ? [...filtersForAPI, { keywords }] : filtersForAPI;
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())		
		return fetch(`${api.articles}`, {
			method: "POST",
			mode: "cors",
			body: JSON.stringify({
				// ai: false,
				// asc: false,
				// analystSystem: false,
				// desc: true,
				endDate: endDate || Number(moment().add(7, "days").format("x")),
				filters: filterWithKeywords,
				// narratives,
				// perspective: "Source",
				// project: 'e785c152058a28fac18d3f3e1a7088dc', // mock filters - GEC
				project: api.key,
				// showDuplicates: false,
				// sort: "postDate",
				// relevancy: 0.65,
				// slice: 15,
				startDate: startDate || Number(moment().subtract(7, "days").format("x")),
				user: `${userName}_${userPool}`,
				videoTab: true,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
				// 'Access-Control-Allow-Origin': '*',
			},
		})
			.then((response) => response.json())
			.then((json) => dispatch({ type: RECEIVE_VIDEO_FEED, videoFeed: json, fetchKey }))
			.catch((error, json) => {
				console.error("RECEIVE_VIDEO_FEED error", error);
			});
	};
};

export const fetchVideoEntities = (params) => {
	const { endDate, startDate, fetchKey, filtersList, keywords } = params;

	return (dispatch, getState) => {
		const { api, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const userPool = userData && userData.pool && userData.pool.userPoolId;

		const filtersForAPI = formatFiltersForPost(filtersList);
		const filterWithKeywords = keywords && keywords.length > 0 ? [...filtersForAPI, { keywords }] : filtersForAPI;
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		const body = JSON.stringify({
			ai: false,
			analystSystem: false,
			endDate: endDate || Number(moment().add(7, "days").format("x")),
			event: false,
			filters: filterWithKeywords,
			perspective: "Source",
			project: api.key,
			max: 500,
			relevancy: 0.65,
			slice: 15,
			startDate: startDate || Number(moment().subtract(7, "days").format("x")),
			user: `${userName}_${userPool}`,
			videoTab: true,
		});

		return fetch(`${api.entities}`, {
			method: "POST",
			mode: "cors",
			body,
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
				// 'Access-Control-Allow-Origin': '*',
			},
		})
			.then((response) => response.json())
			.then((json) => {
				dispatch({
					type: RECEIVE_VIDEO_ENTITIES,
					entities: json,
					fetchKey,
				});
			})
			.catch((error, json) => {
				console.error(error, json);
			});
	};
};

export const fetchVideo = (video) => {
	return (dispatch, getState) => {
		const { api, userEmail, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		// return fetch(`${api.singleArticle}?id=${video.id}&ai=false&index=${video.index}&language=${language}&shares=${shares}&email=${userEmail}`, {
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())		
		return fetch(`${api.singleArticle}?id=${video.id}&ai=false&index=${video.index}&email=${userEmail}`, {
			method: "GET",
			mode: "cors",
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => response.json())
			.then((json) => {
				dispatch({
					type: RECEIVE_VIDEO_DATA,
					video: json,
				});
				// FLAG_ATTEMPTING_TO_TRANSLATE_MISSING_TRANSCRIPTS
				// console.log("", json);
				const hasTranscript = json.transcriptJson && json.transcriptJson.transcriptHtml;
				const noTranslation = !json.translationJson || !json.translationJson.segments;
				if (hasTranscript && noTranslation) {
					dispatch(translateTranscript({ data: json }));
					// const callsRequired = Math.ceil(json.transcriptJson.segments.length / 50);
					// _.times(callsRequired, (index) => {
					// 	setTimeout(() => {
					// 		dispatch(translateTranscript({ data: json, index, callsRequired }));
					// 	}, 50);
					// });
				}
			})
			.catch((error) => {
				console.error("Error in fetchVideo fetch", error);
			});
	};
};

// export const fetchTopicStats = (parameters) => {
// 	const {
// 		currentFilters,
// 		endDate,
// 		dataType,
// 		fetchKey,
// 		filtersList,
// 		narrative,
// 		perspective,
// 		relevancy,
// 		startDate,
// 	} = parameters;
// 	return (dispatch, getState) => {
// 		const staging = getState().base.stagingData;
// 		const { api, userData, userName, authToken } = getState().login;
// 		const { aiOnly, aiSupport } = getState().commonUI;
// 		const { percentageTypes, analystSystem } = getState().projectConfig;
// 		const userPool = userData && userData.pool && userData.pool.userPoolId;
// 		const chartType = dataType ? dataType.id : "articleCount";

// 		const topicStatsConfig = [
// 			{
// 				id: "chinaAggregated",
// 				name: "China",
// 				// value: 812949,
// 				// beginDate: 1597881600000,
// 				// endDate: 1599696000000,
// 				children: [
// 					{
// 						id: "chinaTopic",
// 						name: "Anti CCP",
// 						// value: 500000,
// 						anti: true,
// 					},
// 					{
// 						id: "pchinaTopica",
// 						name: "Pro CCP",
// 						// value: 312949,
// 					},
// 				],
// 			},
// 			{
// 				id: "usAggregated",
// 				name: "US",
// 				// value: 143932,
// 				// beginDate: 1597881600000,
// 				// endDate: 1599696000000,
// 				left: true,
// 				children: [
// 					{
// 						id: "nusTopica",
// 						name: "Anti US",
// 						// value: 100000,
// 						anti: true,
// 					},
// 					{
// 						id: "usTopic",
// 						name: "Pro US",
// 						// value: 43932,
// 					},
// 				],
// 			},
// 		];
// 		const allChildren = [...topicStatsConfig[0].children, ...topicStatsConfig[1].children]; // assumes just 2 topics

// 		if (topicStatsConfig && allChildren) {
// 			dispatch({ type: SETUP_TOPIC_STATS, topicStatsConfig, expectedNarratives: allChildren.length });

// 			_.each(allChildren, (child) => {
// 				const params = JSON.stringify({
// 					aggregate: 7,
// 					ai: aiOnly,
// 					analystSystem,
// 					// FLAG_DISABLED_GRAPH_DATA_TYPE_SELECTOR_IN_REACTION
// 					chartType: perspective !== "Audience" ? chartType : "articleCount",
// 					endDate: endDate ? endDate.toString() : null,
// 					event: false,
// 					narrative: child.id,
// 					parent: child.parent,
// 					perspective,
// 					project: api.key,
// 					filters: formatFiltersForPost(alignPerspectiveOnLocationFilters(filtersList, perspective)),
// 					startDate: startDate ? startDate.toString() : null,
// 					relevancy,
// 					user: `${userName}_${userPool}`,
// 				});

// 				return fetch(`${api.timeseries}?staging=${staging}`, {
// 					method: "POST",
// 					mode: "cors",
// 					body: params,
// 					headers: {
// 						"Content-Type": "application/json",
// 					},
// 				})
// 					.then((response) => response.json())
// 					.then((json) =>
// 						dispatch({
// 							type: RECEIVE_TOPIC_STATS,
// 							timeseries: json,
// 							narrative: child,
// 						})
// 					)
// 					.catch((error) => {
// 						console.error(error);
// 					});
// 			})
// 		}

// 	};
// }

export function fetchStats() {
	return (dispatch, getState) => {
		const { api, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { aiOnly } = getState().commonUI;
		const staging = getState().base.stagingData;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		if (api.stats) {
			return fetch(`${api.stats}?staging=${staging}`, {
				method: "POST",
				mode: "cors",
				body: JSON.stringify({
					project: api.key,
					ai: aiOnly,
					user: `${userName}_${userPool}`,
				}),
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			})
				.then((response) => response.json())
				.then((json) => dispatch({ type: "receiveStats", data: json }))
				.catch((error, json) => {
					console.log("fetchStats error", json);
					console.error("fetchStats error", error);
				});
		} else {
			console.warn("Stats endpoint not defined");
		}
	};
};

export function fetchTimeseriesList(params) {
	// aiOverride only appears when calling a saved view
	// facet and option only appear when updating a facet
	const { aiOverride, facet, option } = params;
	return (dispatch, getState) => {
		const { api, userData, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { aiOnly } = getState().commonUI;
		const { graphTabActiveFacets, graphTabFacets } = getState().projectConfig;
		const staging = getState().base.stagingData;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		let activeFacets = false;
		let facetString = "";
		// replicate facetSelect reducer (so there's not a timing issue)
		if (graphTabFacets) {
			activeFacets = JSON.parse(JSON.stringify(graphTabActiveFacets));
			if (facet && option) {
				activeFacets[facet.id] = option;
			}
			_.each(activeFacets, (activeFacet, facetId) => {
				facetString = `${facetString}&${facetId}=${activeFacet.id}`;
			});
		}

		if (api.listTimeseries && userPool) {
			return fetch(`${api.listTimeseries}?staging=${staging}&ai=${typeof aiOverride !== "undefined" ? aiOverride : aiOnly}${facetString}`, {
				method: "GET",
				mode: "cors",
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			})
				.then((response) => response.json())
				.then((json) => {
					dispatch({ type: "receiveTimeseriesList", availableLines: json });
				})
				.catch((error, json) => {
					console.log("fetchTimeseriesList error", json);
					console.error(">>>>>>> fetchTimeseriesList error", error);
				});
		} else {
			if (!api.listTimeseries) {
				console.warn("listTimeseries endpoint not defined");
			}
			if (!userPool) {
				console.warn("User ID not defined");
			}
		}
	};
};

// Get the current user's list of filter
export function fetchSavedFilters() {
	return (dispatch, getState) => {
		const { api, currentProject, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		// const userId = "Dave_blah"; // mocked in Dynamo
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		const userId = `${userName}_${userPool}`;
		return fetch(`${api.saveFilters}/${userId}`, {
			method: "GET",
			mode: "cors",
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => response.json())
			.then((json) => {
				dispatch({ type: "receiveSavedFilters", savedFilters: json && json.payload, currentProject });
			})
			.catch((error, json) => {
				console.log("receiveSavedFilters error", json);
				console.error("receiveSavedFilters error", error);
			});
	};
};

export function saveFilterSet(params) {
	const { perspective } = params;
	return (dispatch, getState) => {
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		dispatch({
			type: SAVE_FILTER_SET_SPINNER,
			payload: {
				saveFilterSpinner: true,
				saveFilterError: false,
			},
		});
		const { api, currentProject, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const {
			entityFiltersListedInModal,
			filtersListedInModal,
			saveFilterModalData,
			saveFilterEditMode,
			saveFilterModalName,
		} = getState().commonUI;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		const userId = `${userName}_${userPool}`;
		const filter = {
			userId,
			filterSetId: saveFilterModalData.filterSetId, // Used for DELETE. Ignored when saving
			project: currentProject,
			name: saveFilterModalName,
			perspective,
			filters: filtersListedInModal,
			entityFilters: perspective === "Source" ? entityFiltersListedInModal : [], // just in case
			// used to match against active filters.
			filterString: describeFilters({
				filtersList: mergeEntityFilters({
					activeFilters: _.reject(filtersListedInModal, (filt) => {
						return filt.parent === "keywords";
					}), // Keywords are in here
					entityFilters: entityFiltersListedInModal,
					perspective,
					keywords: _.filter(filtersListedInModal, (filt) => {
						return filt.parent === "keywords";
					}),
				}),
			}),
		};

		// If we're updating the filter, delete the old one then we'll make a new one (dynamoDB UpdateItem is not cooperating)
		if (saveFilterEditMode) {
			dispatch(deleteSavedFilter({ filter }));
		}

		return fetch(api.saveFilters, {
			method: "POST",
			mode: "cors",
			body: JSON.stringify(filter),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
				// 'Access-Control-Allow-Origin': '*',
			},
		})
			.then((response) => response.json())
			.then((json) => {
				filter.filterSetId = json ? json.id : "failedId";
				dispatch({ type: "saveFilterSetSuccess", response: json, filter });
				setTimeout(() => {
					dispatch({ type: "closeSaveFilterModal" });
				}, 1000);
			})
			.catch((error) => {
				dispatch({ type: "saveFilterSetError" });
				console.error("saveFilterSet error", error);
			});
	};
};

export function deleteSavedFilter(params) {
	const { filter } = params;
	return (dispatch, getState) => {
		dispatch({ type: "closeDeleteFilterModal" });
		dispatch({ type: "proactivelyRemoveFilterSet", filter });
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		const { api, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const userPool = userData && userData.pool && userData.pool.userPoolId;

		const userId = `${userName}_${userPool}`;

		return fetch(api.saveFilters, {
			method: "DELETE",
			mode: "cors",
			body: JSON.stringify({
				userId,
				filterSetId: filter.filterSetId,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
				// 'Access-Control-Allow-Origin': '*',
			},
		})
			.then((response) => response.json())
			.then((json) => {
				console.log("deleteFilterSetSuccess", json);
				// dispatch({ type: "deleteFilterSetSuccess" }); // No need, nothing needs to happen
			})
			.catch((error) => {
				dispatch({ type: "deleteFilterSetError", filter });
				console.error("deleteFilterSetError error", error);
			});
	};
};

// UNMOCK: with below
export const saveThisSearch = (dateOption) => {
	return (dispatch, getState) => {
		const { lines, saveTitleInputValue } = getState().graphTab;
		const { api, userData } = getState().login;
		const { aiOnly } = getState().commonUI;
		const userPool = userData && userData.pool && userData.pool.userPoolId;

		const params = {
			project: api.key,
			userPool,
			userName: userData.username,
			search: lines,
			id: md5(saveTitleInputValue + userData.username),
			name: saveTitleInputValue,
			dateOption,
			ai: aiOnly,
		};
		console.log("save this search", params);

		dispatch({ type: "saveThisSearchConfirmation", response: "something from the API", params });
		setTimeout(() => {
			dispatch({ type: "clearSavedSearchAnimation" });
		}, 1000);
	};
};
// export const saveThisSearch = (dateOption) => {
// 	return (dispatch, getState) => {
// 		// API_STUB: save this stuff to S3
// 		const { lines, saveTitleInputValue } = getState().graphTab;
// 		const { api, userData } = getState().login;
// const { aiOnly } = getState().commonUI;
// 		const staging = getState().base.stagingData;
// 		const userPool = userData && userData.pool && userData.pool.userPoolId;
// 		console.log("userData", userData);
// 		// API_STUB: saveSearch
// 		if (api.saveSearch && userPool) {
// 			const params = {
// 				project: api.key,
// 				userPool,
// 				userName: userData.username,
// 				search: lines,
// 				id: md5(saveTitleInputValue + userData.username),
// 				name: saveTitleInputValue,
// 				dateOption,
// ai: aiOnly,
// 			};
// 			console.log('save this search', params);

// 			return fetch(`${api.saveSearch}?staging=${staging}`, {
// 				method: "POST",
// 				mode: "cors",
// 				body: JSON.stringify(params),
// 				headers: {
// 					"Content-Type": "application/json",
// 					// 'Access-Control-Allow-Origin': '*',
// 				},
// 			})
// 				.then((response) => response.json())
// 				.then((json) => dispatch({ type: "saveThisSearchConfirmation", response: json, params }))
// 				.catch((error, json) => {
// 					console.log("saveThisSearch error", json);
// 					console.error("saveThisSearch error", error);
// 				});
// 		} else {
// 			if (!userPool) {
// 				console.warn("User Pool not defined");
// 			}
// 		}
// 	};
// };

export function fetchGraphTabFilters(params) {
	const { filterType } = params;
	return (dispatch, getState) => {
		const { api, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { aiOnly } = getState().commonUI;
		const staging = getState().base.stagingData;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		if (api.getFilters) {
			// return fetch(`${api.getFilters}`, {
			return fetch(`${api.getFilters}?type=${filterType}&staging=${staging}&userName=${userName}&userPool=${userPool}&ai=${aiOnly}`, {
				method: "GET",
				mode: "cors",
				headers: {
					"Content-Type": "application/json",
					Authorizaton: idToken,
					// 'Access-Control-Allow-Origin': '*',
				},
			})
				.then((response) => response.json())
				.then((json) => dispatch({ type: "receiveGraphTabFilters", filters: json.filters, filterType: json.type }))
				.catch((error, json) => {
					console.log("fetchGraphTabFilters error", json);
					console.error("fetchGraphTabFilters error", error);
				});
		} else {
			console.warn("getFilters endpoint not defined");
		}
	};
}

// Gets filter types by not passing a type
export function fetchGraphTabFilterOptions(params) {
	const { aiOverride } = params;
	return (dispatch, getState) => {
		const { api, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { aiOnly } = getState().commonUI;
		const staging = getState().base.stagingData;
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		if (api.getFilters) {
			// return fetch(`${api.getFilters}`, {
			return fetch(`${api.getFilters}?staging=${staging}&ai=${typeof aiOverride !== "undefined" ? aiOverride : aiOnly}`, {
				method: "GET",
				mode: "cors",
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
					// 'Access-Control-Allow-Origin': '*',
				},
			})
				.then((response) => response.json())
				.then((json) => {
					dispatch({ type: "receiveGraphTabFilterOptions", filters: json });
					dispatch(fetchTopicsList({ type: json && json.length > 0 ? json[0].name : "" }));
				})
				.catch((error, json) => {
					console.log("fetchGraphTabFilterOptions error", json);
					console.error("fetchGraphTabFilterOptions error", error);
				});
		} else {
			console.warn("getFilters endpoint not defined");
		}
	};
}

export function fetchTopicsList(params) {
	const { type } = params;
	return (dispatch, getState) => {
		const { api, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { aiOnly } = getState().commonUI;
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		// const staging = getState().base.stagingData;
		if (api.getTopics) {
			return fetch(`${api.getTopics}?type=${type}&ai=${aiOnly}`, {
				method: "GET",
				mode: "cors",
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
					// 'Access-Control-Allow-Origin': '*',
				},
			})
				.then((response) => response.json())
				.then((json) =>
					dispatch({
						type: "receiveGraphTabTopics",
						topics: json && json.topics && json.topics.children ? json.topics.children : [],
					})
				)
				.catch((error, json) => {
					console.log("fetchTopicsList error", json);
					console.error("fetchTopicsList error", error);
				});
		} else {
			console.warn("getTopics endpoint not defined");
		}
	};
}

// project: string
// type: string
// name: string
// filters: [
// 	{
// 		filterTypeA: [ filterIdString, ... ]
// 	},
// 	{
// 		filterTypeB: [ filterIdString, ... ]
// 	}
// ],
// topics: [ topic_md5id, subtopic_md5id, narrative_md5id, ...],
// keywords: string - any valid elastic search query

// // API_STUB: unmock with below
// export const createNewTimeseries = () => {
// 	return (dispatch, getState) => {
// 		// TODO: get active filters
// 		const {
// 			availableFilters,
// 			createTitleKeywordValue,
// 			createTitleInputValue,
// 			createTitleUnique,
// 			currentFilterType,
// 			selectedFilters,
// 			selectedTimeSeries,
// 		} = getState().graphTab;

// 		if (!createTitleUnique ||
// 				!createTitleInputValue ||
// 				((selectedTimeSeries <= 0 && !createTitleKeywordValue) ||
// 					(selectedTimeSeries.length <= 1 &&
// 						selectedFilters.length <= 0 &&
// 						!createTitleKeywordValue))
// 		) {
// 			dispatch({ type: "showCreateCustomTimeseriesError", duplicateTitle: !createTitleUnique, missingTitle: !createTitleInputValue });
// 		} else {
// 			dispatch({ type: "hideCreateCustomTimeseriesError" });
// 			const currentFilter = _.find(availableFilters, (filter) => {
// 				return filter.id === currentFilterType;
// 			});
// 			const { api, userName, authToken } = getState().login;
// 			// const staging = getState().base.stagingData;
// 			if (api.createTimeseries) {
// 				dispatch({ type: "requestCreateNewTimeseries" });

// 				// This is the MOCKed part
// 				setTimeout(() => {
// 					dispatch({ type: "receiveCreateNewTimeseries", data: mockCreateResponse });
// 					// Turn the spinner off after the animation finishes (can't leave it on, it will kill the battery)
// 					setTimeout(() => {
// 						dispatch({ type: "disableRequestingTimeSeriesSpinner" });
// 					}, 1000);
// 				}, 1000);
// 				// Grab the updated data
// 				// API_STUB: write a new version of fetchTimeseriesList that checks for the new TS's id in the response
// 				//	& refetches after a delay if it's not available
// 				setTimeout(() => {
// 					dispatch(fetchTimeseriesList({}));
// 				}, 3000); // 2 seconds after receiving response

// 			} else {
// 				console.warn("createTimeseries endpoint not defined");
// 			}
// 		}
// 	};
// };

export const createNewTimeseries = () => {
	return (dispatch, getState) => {
		// TODO: get active filters
		const {
			availableFilters,
			createTitleKeywordValue,
			createTitleInputValue,
			createTitleUnique,
			currentFilterType,
			selectedFilters,
			selectedTimeSeries,
		} = getState().graphTab;
		const { percentageTypes } = getState().projectConfig;

		if (
			!createTitleUnique ||
			!createTitleInputValue ||
			(selectedTimeSeries <= 0 && !createTitleKeywordValue) ||
			(selectedTimeSeries.length <= 1 && selectedFilters.length <= 0 && !createTitleKeywordValue)
		) {
			dispatch({
				type: "showCreateCustomTimeseriesError",
				duplicateTitle: !createTitleUnique,
				missingTitle: !createTitleInputValue,
			});
		} else {
			dispatch({ type: "hideCreateCustomTimeseriesError" });
			const currentFilter = _.find(availableFilters, (filter) => {
				return filter.id === currentFilterType;
			});
			// API_STUB: get this working
			// forcibly refresh tokens
			Auth.currentSession().catch(() => dispatchTokenFailure())
			const { api, userData, userName, authToken } = getState().login;
			const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
			const { aiOnly } = getState().commonUI;
			const userPool = userData && userData.pool && userData.pool.userPoolId;
			// const staging = getState().base.stagingData;
			if (api.createTimeseries) {
				dispatch({ type: "requestCreateNewTimeseries" });
				return fetch(api.createTimeseries, {
					method: "POST",
					mode: "cors",
					body: JSON.stringify({
						project: api.key,
						index: currentFilter && currentFilter.index,
						type: currentFilterType,
						name: createTitleInputValue,
						filters: formatFiltersForPost(selectedFilters),
						topics: _.pluck(selectedTimeSeries, "id"),
						keywords: createTitleKeywordValue,
						ai: aiOnly,
						user: `${userName}_${userPool}`,
					}),
					headers: {
						"Content-Type": "application/json",
						Authorization: idToken,
						// 'Access-Control-Allow-Origin': '*',
					},
				})
					.then((response) => response.json())
					.then((json) => {
						dispatch({ type: "receiveCreateNewTimeseries", data: json, percentageTypes });
						// Turn the spinner off after the animation finishes (can't leave it on, it will kill the battery)
						setTimeout(() => {
							dispatch({ type: "disableRequestingTimeSeriesSpinner" });
						}, 1000);
						// API_STUB: write a new version of fetchTimeseriesList that checks for the new TS's id in the response
						//	& refetches after a delay if it's not available
						setTimeout(() => {
							dispatch(fetchTimeseriesList({}));
						}, 2000);
					})
					.catch((error, json) => {
						console.log("createNewTimeseries error", json);
						console.error("createNewTimeseries error", error);
					});
			} else {
				console.warn("createTimeseries endpoint not defined");
			}
		}
	};
};

// API_STUB: Check all this - especially body.delete
export function deleteTimeseries(line) {
	return (dispatch, getState) => {
		const { api, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const staging = getState().base.stagingData;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		if (api.deleteTimeseries) {
			// forcibly refresh tokens
			Auth.currentSession().catch(() => dispatchTokenFailure())
			
			return fetch(`${api.deleteTimeseries}?staging=${staging}`, {
				method: "POST",
				mode: "cors",
				body: JSON.stringify({
					project: api.key,
					delete: line,
					user: `${userName}_${userPool}`,
				}),
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
					// 'Access-Control-Allow-Origin': '*',
				},
			})
				.then((response) => response.json())
				.then((json) => dispatch({ type: "deleteTimeseriesSuccess", response: json, line }))
				.catch((error, json) => {
					dispatch({ type: "deleteTimeseriesError", error, json, line });
					console.log("deleteTimeseries error", json);
					console.error("deleteTimeseries error", error);
				});
		} else {
			console.warn("deleteTimeseries endpoint not defined");
		}
	};
};

// MOCKED: failure
// export function deleteSavedSearch(search) {
// 	return (dispatch, getState) => {
// 		const { api, userName, authToken } = getState().login;
// 		const staging = getState().base.stagingData;
// 		dispatch({ type: "deleteSavedSearchError", error: "This is an error message", json: {}, search });
// 	};
// }
// API_STUB: test all this
export function deleteSavedSearch(search) {
	return (dispatch, getState) => {
		const { api, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const staging = getState().base.stagingData;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		if (api.deleteSavedSearch) {
			// forcibly refresh tokens
			Auth.currentSession().catch(() => dispatchTokenFailure())
			
			return fetch(`${api.deleteSavedSearch}?staging=${staging}`, {
				method: "POST",
				mode: "cors",
				body: JSON.stringify({
					project: api.key,
					delete: search,
					user: `${userName}_${userPool}`,
				}),
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
					// 'Access-Control-Allow-Origin': '*',
				},
			})
				.then((response) => response.json())
				.then((json) => dispatch({ type: "deleteSavedSearchSuccess", response: json, search }))
				.catch((error, json) => {
					dispatch({ type: "deleteSavedSearchError", error, json, search });
					console.log("deleteSavedSearch error", json);
					console.error("deleteSavedSearch error", error);
				});
		} else {
			console.warn("deleteSavedSearch endpoint not defined");
		}
	};
};

export function fetchAnalysis(baseTrendMeta) {
	return (dispatch, getState) => {
		dispatch(requestAnalysis());
		const { api, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { aiOnly } = getState().commonUI;
		api.optionsForGET["headers"]["authorization"] = idToken
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		// Getting full analysis. Pass 'narrative_id' to just get specific analysis (doesn't work right now)
		return fetch(`${api.analysis}?ai=${aiOnly}`, api.optionsForGET)
			.then((response) => response.json())
			.then((json) => dispatch(receiveAnalysis(json, baseTrendMeta)))
			.catch((error) => {
				console.error(error);
			});
	};
};

let articlesAbortController;
const abortArticlesFetch = () => {
	if (articlesAbortController) {
		articlesAbortController.abort();
	}
}

function doFetchArticles(parameters) {
	const {
		adjustForAggregation = false,
		dispatch,
		getState,
		sortAscending,
		analystSystem,
		perspective,
		currentFilters,
		endDate,
		eventType,
		fetchKey,
		filtersList,
		narrative,
		relevancy,
		showDuplicates,
		sortBy,
		startDate,
		pageLength,
		offset
	} = parameters;

	const staging = getState().base.stagingData;
	const { api, userData, userName, authToken } = getState().login;
	const { aiOnly } = getState().commonUI;
	const { projectSpecificTagFormat } = getState().projectConfig;
	const { aggregationLevel, articlesFetchingRetryCount } = getState().base;

	const narrativeId = (narrative && (narrative.id !== "narratives")) ? narrative.id : null;
	const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
	const userPool = userData && userData.pool && userData.pool.userPoolId;
	const backupShowDuplicates = getState().base.showDuplicates;

	articlesAbortController = new AbortController();
	
	// forcibly try to refresh id/access tokens
	Auth.currentSession().catch(() => dispatchTokenFailure())

	return fetch(`${api.articles}?staging=${staging}`, {
		method: "POST",
		signal: articlesAbortController.signal,
		mode: "cors",
		body: JSON.stringify({
			ai: aiOnly,
			asc: sortAscending,
			analystSystem,
			desc: !sortAscending,
			endDate: endDate || Date.now(),
			event: eventType,
			filters: formatFiltersForPost(filtersList),
			narrative: narrativeId,
			parent: narrativeId ? narrative.parent : null,
			perspective,
			project: api.key,
			showDuplicates: typeof showDuplicates === "undefined" ? backupShowDuplicates : showDuplicates,
			slice: 15,
			sort: sortBy ? [sortBy] : [],
			relevancy,
			startDate: adjustForAggregation 
				? adjustStartDateForAggregation({startDate, aggregationLevel}).toString() 
				: startDate,
			user: `${userName}_${userPool}`,
			pageLength,
			offset,
		}),
		headers: {
			"Content-Type": "application/json",
			Authorization: idToken,
		},
	})
	.then((response) => {
		if (!response.ok) {
			throw new Error(SERVER_ERROR);
		}
		return response.json()
	})
	.then((json) => {
		return dispatch(
			receiveArticles({
				articles: json,
				narrative,
				perspective,
				filtersList,
				currentFilters,
				projectSpecificTagFormat,
				fetchKey,
			})
		)
	})
	.catch((error) => {
		if (error.name === 'AbortError') {
			// No action needed
			console.log('Article fetch request aborted');
		}
		else if (articlesFetchingRetryCount >= FETCH_RETRY_MAX) {
			console.error(error);
			dispatch({type: RECEIVE_ARTICLES_ERROR});
		}
		else {
			console.warn(`${error} - Retry attempt ${articlesFetchingRetryCount + 1}...`);
			dispatch({type: RECEIVE_ARTICLES_RETRY});
			doFetchArticles(parameters);
		}
	})
}

export function fetchArticlesInit(params) {
	const { startDate, endDate, relevancy } = params;
	// console.log("fetchArticlesInit", narratives);
	return (dispatch, getState) => {
		const {
			contentHeaderSortAscendingSource,
			contentHeaderSortAscendingAudience,
			perspective,
			showDuplicates,
			articlesFetching,
			pageLength,
			offset,
		} = getState().base;

		if (articlesFetching) {
			abortArticlesFetch();
		}
		dispatch({ type: "requestArticles" });
		const { analystSystem, projectMapConfig } = getState().projectConfig;
		const configStateFilter = projectMapConfig && projectMapConfig.narratives && projectMapConfig.narratives.state;
		const baseFilters = perspective === "Source" ? getState().base.sourceFilters : getState().base.audienceFilters;
		const filtersList = configStateFilter ? addConfigFilters([], configStateFilter, baseFilters) : [];
		const allFilters = configStateFilter ? reactivateFilters(baseFilters, filtersList) : baseFilters;

		// Set the sort variables by perspective
		const contentHeaderSortAscending = perspective === "Source" ? contentHeaderSortAscendingSource : contentHeaderSortAscendingAudience;

		return doFetchArticles({
			dispatch,
			getState,
			sortAscending: contentHeaderSortAscending,
			analystSystem,
			perspective: "Source",
			currentFilters: allFilters,
			endDate,
			filtersList,
			relevancy,
			showDuplicates,
			startDate,
			pageLength: pageLength || CONTENT_PAGE_LENGTH,
			offset: offset || 0,
		});
	};
};

export function fetchArticles(parameters) {
	const {
		ascending,
		currentFilters,
		endDate,
		fetchKey,
		filtersList,
		narrative,
		perspective,
		relevancy,
		showDuplicates,
		sortBy,
		startDate,
		pageLength,
		offset,
	} = parameters;
	// perspective: string. must be 'Audience' or 'Source'

	return (dispatch, getState) => {
		const narrativeId = narrative.id !== "narratives" ? narrative.id : null;
		const {	articlesFetching } = getState().base;
		const { analystSystem } = getState().projectConfig;

		if (articlesFetching) {
			abortArticlesFetch();
		}

		dispatch({ type: "requestArticles", narrativeId });

		return doFetchArticles({
			dispatch,
			getState,
			sortAscending: ascending,
			analystSystem,
			perspective,
			currentFilters,
			endDate,
			eventType: isThisAnEvent({ id: narrativeId, events: getState().events.eventTypes }),
			fetchKey,
			filtersList,
			narrative,
			relevancy,
			showDuplicates,
			sortBy,
			startDate,
			pageLength,
			offset,
		});
	};
};

// Individual article data
export function fetchArticleData(params) {
	// log(['fetch.js 1381 - fetchArticleData', params]);
	return (dispatch, getState) => {
		const { aiOnly, distractionFreeDeveloperMode } = getState().commonUI;
		const { analystSystem, expandedContentShowTweets, fakeSingleArticle } = getState().projectConfig;
		const { api, userEmail, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { fdate, id, index, nav, language, shares, source, title } = params;

		const isGECAnalyst = analystSystem && api.project === "gec";
		// forcibly try to refresh id/access tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(
			`${api.singleArticle}?id=${
				fakeSingleArticle ? 14761 : id
			}&ai=${!!aiOnly}&index=${index}&language=${language}&navigation=${nav}&shares=${shares}&email=${userEmail}&projectGecAnalyst=${isGECAnalyst}`,
			{
				method: "GET",
				mode: "cors",
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			}
		)
			.then((response) => response.json())
			.then((json) => {
				dispatch({
					type: "receiveArticleData",
					data: json,
					narratives: getState().base.flatNarratives,
					id,
					index,
					distractionFreeDeveloperMode,
				});
				const weShouldLoadTweets = expandedContentShowTweets && json.external_url;

				if (weShouldLoadTweets) {
					dispatch(resolveRedirectedURL({ url: json.external_url, exoid: json.exoveraId, source: source || json.source, fdate, title }));
				}
			})
			.catch((error) => {
				console.error(error);
			});
	};
};

export function fetchUnsafe(article) {
	return (dispatch, getState) => {
		const { aiOnly } = getState().commonUI;
		const { api, userEmail, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		console.log("unsafe articleID: ", article);
		// forcibly try to refresh id/access tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		if (article["__typename"] === "TelegramPost") {
			return dispatch({
				type: "receiveUnsafeArticle",
				data: article,
			});
		}
		return fetch(`${api.singleArticle}?id=${article.id}&ai=${aiOnly}&getDoc=unsafe&email=${userEmail}`, {
			method: "GET",
			mode: "cors",
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => response.json())
			.then((json) =>
				dispatch({
					type: "receiveUnsafeArticle",
					data: json,
				})
			)
			.catch((error) => {
				console.error(error);
			});
	};
};

export function resolveRedirectedURL(params) {
	const { url, exoid, fdate, source, title } = params;

	const thresholdMoment = moment().subtract(3, "days");
	const articleMoment = moment(fdate * 1000);
	const useCached = articleMoment.isBefore(thresholdMoment);

	return (dispatch, getState) => {
		const { api } = getState().login;

		dispatch({ type: FETCHING_TWEETS });
		if (source) {
			dispatch({ type: FETCHING_POST_COMMENTS });
		}

		return fetch(api.resolveRedirect, {
			method: "POST",
			mode: "cors",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ url, exoid }),
		})
			.then((response) => response.json())
			.then((json) => {
				// console.log('==== resolveRedirectedURL ====>', json);
				if (_.isObject(json) && json.errorMessage) {
					dispatch({ type: ERROR_LOADING_TWEETS, error: json });
				} else {
					dispatch(fetchTwitterData({ url: json.url, useCached }));
					if (source) {
						dispatch(fetchArticleComments({ url: json.url, source, title, useCached }));
					}
				}
			})
			.catch((error) => {
				dispatch({ type: ERROR_LOADING_TWEETS, error });
			});
	};
};

export function fetchTwitterData(params) {
	const { url, useCached } = params;
	const tweetType = "popular"; // popular, mixed or recent
	const tweetLimit = 20;

	return (dispatch, getState) => {
		const { api, userName, authToken } = getState().login;
		// const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		dispatch({ type: FETCHING_TWEETS });

		return fetch(`${api.searchTwitter}?url=${url}`, {
			// return fetch(`${api.searchTwitter}?url=${url}&type=${tweetType}&limit=${tweetLimit}&cached=${useCached ? "true" : "false"}`, {
			method: "GET",
			mode: "cors",
			headers: {
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((json) => {
				dispatch({
					type: RECEIVE_TWEETS,
					tweets: json.tweets,
				})
			}
		
			
			)
			.catch((error) => {
				dispatch({ type: ERROR_LOADING_TWEETS, error });
			});
	};
};

export function fetchArticleComments(params) {
	const { useCached, url, source, title } = params;
	// console.log('fetchArticleComments', params);

	return (dispatch, getState) => {
		const { api, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		// forcibly try to refresh id/access tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(
			`${api.getPostId}?source_name=${encodeURIComponent(source)}&url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}`,
			{
				method: "GET",
				mode: "cors",
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			}
		)
			.then((response) => response.json())
			.then((json) => {
				if (json.error) {
					dispatch({ type: NO_POST_COMMENTS, error: json.error });
				} else {
					dispatch(fetchPostComments({ source: json.page_name, postId: json.post_id, useCached }));
				}
			})
			.catch((error) => {
				console.log("fetchArticleComments error", error);
				dispatch({ type: NO_POST_COMMENTS });
			});
	};
};

export function fetchPostComments(params) {
	const { postId, source, useCached } = params;
	return (dispatch, getState) => {
		const { api, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(
			`${api.getPostComments}?page_name=${encodeURIComponent(source)}&post_id=${encodeURIComponent(postId)}&cached=${
				useCached ? "true" : "false"
			}`,
			{
				method: "GET",
				mode: "cors",
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			}
		)
			.then((response) => response.json())
			.then((json) => {
				if (json.error) {
					dispatch({ type: NO_POST_COMMENTS });
				} else {
					dispatch({
						type: RECEIVE_POST_COMMENTS,
						comments: json.comments,
					});
				}
			})
			.catch((error) => {
				console.log("fetchArticleComments error", error);
				dispatch({ type: NO_POST_COMMENTS });
			});
	};
};

// Map data
export function fetchArticleMapData(stateCode, articleID) {
	// stateCode === null for base map
	return (dispatch, getState) => {
		const staging = getState().base.stagingData;
		const { api, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { aiOnly } = getState().commonUI;
		const { analystSystem } = getState().projectConfig;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(`${api.map}?staging=${staging}`, {
			method: "POST",
			mode: "cors",
			body: JSON.stringify({
				// startDate: startDate ? startDate.toString() : null,
				// endDate: endDate ? endDate.toString() : null,,
				// narrative,
				// filters: [],
				analystSystem,
				articleID,
				slice: 15,
				includeCounties: !!stateCode, // back end needs a boolean, not just something truthy
				project: api.key,
				state: stateCode || null,
				perspective: "Audience",
				ai: aiOnly,
				user: `${userName}_${userPool}`,
				aggregationType: stateCode ? "county" : "state", // state/county/dma
				// NOTE: no relevancy data for this call, which I assume is correct (this feature wasn't installed when relevancy data was added)
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => response.json())
			.then((json) =>
				dispatch({
					type: "receiveArticleMapData",
					map: json,
					articleID,
					stateCode,
				})
			)
			.catch((error) => {
				console.error("fetchArticleMapData error:", error);
			});
	};
};

export function fetchDataExplorerDocument(params) {
	// console.log("fetchDataExplorerDocument", params);
	return (dispatch, getState) => {
		const { api, userEmail, userName, authToken } = getState().login;
		const { activeSearchObj, expandedQuery } = getState().dataExplorer;
		const queryString = expandedQuery || (activeSearchObj ? activeSearchObj.query : "");
		// const queryString = activeSearchObj ? activeSearchObj.query : "";
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { id, index } = params;
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(`${api.singleArticle}?id=${id}&index=${index}&email=${userEmail}&query=${queryString}`, {
			method: "GET",
			mode: "cors",
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => response.json())
			.then((json) => {
				dispatch({
					type: RECEIVE_DATA_EXPLORER_SINGLE_ARTICLE,
					data: json,
					id,
				});
			})
			.catch((error) => {
				console.error(error);
			});
	};
};

// JBN document metadata
let dataExplorerPDFDataAbortController = {};
const abortDataExplorerPDFDataFetch = () => {
	if (dataExplorerPDFDataAbortController) {
		dataExplorerPDFDataAbortController.abort();
	}
}
function doFetchDataExplorerPDFData(params) {
	const { dispatch, getState, id, index } = params;
	const { api, userEmail, userName, authToken } = getState().login;
	const { activeSearchObj, dataExplorerPDFModalDataRetryCount, expandedQuery } = getState().dataExplorer;
	const queryString = expandedQuery || (activeSearchObj ? activeSearchObj.query : "");
	// const queryString = activeSearchObj ? activeSearchObj.query : "";
	const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
	// forcibly refresh tokens
	Auth.currentSession().catch(() => dispatchTokenFailure())
	return fetch(`${api.singleArticle}?id=${id}&index=${index}&email=${userEmail}&query=${queryString}`, {
		method: "GET",
		signal: dataExplorerPDFDataAbortController.signal,
		mode: "cors",
		headers: {
			"Content-Type": "application/json",
			Authorization: idToken,
		},
	})
		.then((response) => {
			if (!response.ok) {
				throw new Error(SERVER_ERROR);
			}
			return response.json();
		})
		.then((json) => {
			dispatch({
				type: RECEIVE_DATA_EXPLORER_PDF_DATA,
				data: json,
				id,
			});
		})
		.catch((error) => {
			if (error.name === 'AbortError') {
				// No action needed
			}
			else if (dataExplorerPDFModalDataRetryCount >= FETCH_RETRY_MAX) {
				console.error(error);
				dispatch({type: RECEIVE_DATA_EXPLORER_PDF_DATA_ERROR});
			}
			else {
				console.warn(`${error} - Retry attempt ${dataExplorerPDFModalDataRetryCount + 1}...`);
				dispatch({type: RECEIVE_DATA_EXPLORER_PDF_DATA_RETRY});
				doFetchDataExplorerPDFData(params);
			}
		});
};

export const fetchDataExplorerPDFData = (params) => {
	const { id, index } = params;
	return (dispatch, getState) => {
		const { dataExplorerPDFModalDataLoading } = getState().dataExplorer;
		if (dataExplorerPDFModalDataLoading) {
			abortDataExplorerPDFDataFetch();
		}
		dataExplorerPDFDataAbortController = new AbortController();
		dispatch({type: FETCHING_DATA_EXPLORER_PDF_DATA, id, index});
		doFetchDataExplorerPDFData({dispatch, getState, id, index});
	};
};

export function fetchPhrases(params) {
	// console.log("fetchPhrases", params);

	const { 
		adjustForAggregation = false,
		endDate, 
		fetchKey, 
		filtersList, 
		narrative, 
		perspective, 
		relevancy, 
		startDate 
	} = params;

	return (dispatch, getState) => {
		dispatch({ type: REQUEST_PHRASES }); // Not installed yet, but will likely be necessary
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		const staging = getState().base.stagingData;
		const { aggregationLevel } = getState().base;
		const { api, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { aiOnly } = getState().commonUI;
		const { analystSystem } = getState().projectConfig;
		const narrativeId = narrative.parent === "self" ? undefined : narrative.id;
		const userPool = userData && userData.pool && userData.pool.userPoolId;

		const body = JSON.stringify({
			ai: aiOnly,
			analystSystem,
			endDate: endDate,
			event: false,
			filters: [],
			// filters: formatFiltersForPost(filtersList),
			parent: narrative.parent,
			perspective,
			project: api.key,
			max: 50,
			narrative: narrativeId,
			relevancy,
			startDate: adjustForAggregation 
				? adjustStartDateForAggregation({startDate, aggregationLevel}).toString() 
				: startDate,
			user: `${userName}_${userPool}`,
		});

		if (!aiOnly) {
			return fetch(`${api.phrases}?staging=${staging}`, {
				method: "POST",
				mode: "cors",
				body,
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			})
				.then((response) => response.json())
				.then((json) =>
					dispatch({
						type: RECEIVE_PHRASES,
						phrases: json,
						fetchKey,
					})
				)
				.catch((error, json) => {
					console.error(error, json);
				});
		}
	};
};

export function fetchComparePhrases(params) {
	const {
		adjustForAggregation = false,
		endDate, 
		fetchKey, 
		filtersList, 
		narrative, 
		perspective, 
		relevancy, 
		startDate, 
		side
	} = params;

	return (dispatch, getState) => {
		dispatch({ type: side === "Left" ? REQUEST_COMPARE_PHRASES_LEFT : REQUEST_COMPARE_PHRASES_RIGHT }); // Not installed yet, but will likely be necessary
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		const staging = getState().base.stagingData;
		const { aggregationLevel } = getState().base;
		const { api, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { aiOnly } = getState().commonUI;
		const { analystSystem } = getState().projectConfig;
		const narrativeId = narrative.parent === "self" ? undefined : narrative.id;
		const userPool = userData && userData.pool && userData.pool.userPoolId;

		const body = JSON.stringify({
			ai: aiOnly,
			analystSystem,
			endDate,
			event: false,
			filters: [],
			// filters: formatFiltersForPost(filtersList),
			parent: narrative.parent,
			perspective,
			project: api.key,
			max: 100,
			narrative: narrativeId,
			relevancy,
			startDate: adjustForAggregation 
				? adjustStartDateForAggregation({startDate, aggregationLevel}).toString() 
				: startDate,
			user: `${userName}_${userPool}`,
		});

		if (!aiOnly) {
			return fetch(`${api.phrases}?staging=${staging}`, {
				method: "POST",
				mode: "cors",
				body,
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			})
				.then((response) => response.json())
				.then((json) =>
					dispatch({
						type: side === "Left" ? RECEIVE_PHRASES_LEFT : RECEIVE_PHRASES_RIGHT,
						phrases: json.phrases,
						fetchKey,
					})
				)
				.catch((error, json) => {
					console.error(error, json);
				});
		}
	};
};

let entitiesAbortController;
const abortEntitiesFetch = () => {
	if (entitiesAbortController) {
		entitiesAbortController.abort();
	}
}

export function fetchEntities(parameters) {
	const {
		adjustForAggregation = false,
		currentFilters, 
		endDate, 
		fetchKey, 
		filtersList, 
		narrative, 
		perspective, 
		relevancy, 
		startDate, 
		translateEntities 
	} = parameters;

	// perspective: string. must be 'Audience' or 'Source'
	return (dispatch, getState) => {
		const staging = getState().base.stagingData;
		const { aggregationLevel, entitiesFetching, entitiesFetchingRetryCount } = getState().base;
		const { api, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { aiOnly } = getState().commonUI;
		const { analystSystem, defaultEntityType, hideEntities } = getState().projectConfig;
		const narrativeId = narrative.parent === "self" ? undefined : narrative.id;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		
		
		if (entitiesFetching) {
			abortEntitiesFetch();
		}
		const body = JSON.stringify({
			ai: aiOnly,
			analystSystem,
			endDate: endDate,
			event: isThisAnEvent({ id: narrativeId, events: getState().events.eventTypes }),
			filters: formatFiltersForPost(filtersList),
			max: 500,
			narrative: narrativeId,
			parent: narrative.parent,
			perspective,
			project: api.key,
			relevancy,
			slice: 15,
			startDate: adjustForAggregation 
				? adjustStartDateForAggregation({startDate, aggregationLevel}).toString() 
				: startDate,
			translate: translateEntities,
			user: `${userName}_${userPool}`,
		});

		if (!aiOnly && !hideEntities) {
			entitiesAbortController = new AbortController();
			// forcibly refresh tokens
			Auth.currentSession().catch(() => dispatchTokenFailure())
			return fetch(`${api.entities}?staging=${staging}`, {
				method: "POST",
				signal: entitiesAbortController.signal,
				mode: "cors",
				body,
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			})
			.then((response) => {
				if (!response.ok) {
					throw new Error(SERVER_ERROR);
				}
				return response.json()
			})
			.then((json) => {
				dispatch({
					type: RECEIVE_ENTITIES,
					data: json,
					defaultEntityType,
					narrative,
					perspective,
					filtersList,
					fetchKey,
				});
			})
			.catch((error, json) => {
				if (error.name === 'AbortError') {
					// No action needed
				}
				else if (entitiesFetchingRetryCount >= FETCH_RETRY_MAX) {
					console.error(error);
					dispatch({
						type: RECEIVE_ENTITIES_ERROR,
						data: json,
						defaultEntityType,
						narrative,
						perspective,
						filtersList,
						fetchKey,
					});
				}
				else {
					console.warn(`${error} - Retry attempt ${entitiesFetchingRetryCount + 1}...`);
					dispatch({type: RECEIVE_ENTITIES_RETRY});
					dispatch(fetchEntities(parameters));
				}
			});
		}
	};
};

// Map mock
// export function fetchMapData(parameters) {
// 	const {
// 		narrative,
// 		dmaAggregation,
// 		perspective,
// 		startDate,
// 		endDate,
// 		filtersList,
// 		currentFilters,
// 		stateCode, // for the state that you want county data for, or false.
// 		fetchKey,
// 	} = parameters;

// 	return (dispatch) => {
// 		dispatch(
// 			receiveMapData({
// 				data: fakeMapData,
// 				narrative,
// 				perspective,
// 				filtersList,
// 				currentFilters,
// 				stateCode,
// 				fetchKey
// 			})
// 		);
// 	};
// }

function doFetchMapData(params) {
	const {
		currentFilters,
		dmaAggregation,
		endDate,
		fetchKey,
		filtersList,
		narrative,
		perspective,
		relevancy,
		startDate,
		stateCode, // for the state that you want county data for, or false.
		newMapSegmentSpan,
		notMOE,
		getState,
		onReceive,
		onError,
		onRetry,
		retryId,
		abortController,
		side
	} = params;

	// perspective: string. must be 'Audience' or 'Source'
	const staging = getState().base.stagingData;
	const { location } = getState().router;
	const { api, userData, userName, authToken } = getState().login;
	const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
	const { aiOnly } = getState().commonUI;
	const { analystSystem } = getState().projectConfig;
	const eventMode = location && location.pathname === "/events";
	const userPool = userData && userData.pool && userData.pool.userPoolId;
	const retryStateId = !side ? 'base' : side === "Left" ? "leftCompare" : "rightCompare";
	const retryCount = getState()[retryStateId][retryId];
	// forcibly refresh tokens
	Auth.currentSession().catch(() => dispatchTokenFailure())
	return fetch(`${api.map}?staging=${staging}`, {
		method: "POST",
		signal: abortController.signal,
		mode: "cors",
		body: JSON.stringify({
			ai: aiOnly,
			analystSystem,
			endDate: endDate ? endDate.toString() : null,
			event: isThisAnEvent({ id: narrative.id, events: getState().events.eventTypes }),
			filters: formatFiltersForPost(alignPerspectiveOnLocationFilters(filtersList, perspective)),
			includeCounties: !!stateCode,
			narrative: notMOE ? (narrative.id === "narratives" ? "ALL" : narrative.id) : undefined,
			moe: !notMOE ? (narrative.id === "narratives" ? "ALL" : narrative.id) : undefined,
			parent: narrative.parent,
			// Force source for events
			perspective: eventMode ? "Source" : perspective,
			project: api.key,
			relevancy,
			slice: determineSliceInDays({ segmentSpan: newMapSegmentSpan, startDate, endDate }),
			startDate: startDate ? startDate.toString() : null,
			state: stateCode || null, // required for aggregationType county
			user: `${userName}_${userPool}`,
			aggregationType: stateCode ? (dmaAggregation ? "dma" : "county") : "state", // state/county/dma
		}),
		headers: {
			"Content-Type": "application/json",
			Authorization: idToken,
		},
	})
	.then((response) => {
		if (!response.ok) {
			throw new Error(SERVER_ERROR);
		}
		return response.json()
	})
	.then((json) => {
		onReceive(json);
	})
	.catch((error) => {
		if (error.name === 'AbortError') {
			// No action needed
			// console.log('Map data fetch request aborted');
		}
		else if (retryCount >= FETCH_RETRY_MAX) {
			console.error(error);
			onError(error);
		}
		else {
			console.warn(`${error} - Retry attempt ${retryCount + 1}...`);
			onRetry(error);
			doFetchMapData(params);
		}
	})
}

// Map data
let mapDataAbortController;
const abortMapDataFetch = () => {
	if (mapDataAbortController) {
		mapDataAbortController.abort();
	}
}

export function fetchMapData(params) {
	const {
		currentFilters,
		dmaAggregation,
		endDate,
		fetchKey,
		filtersList,
		narrative,
		perspective,
		relevancy,
		startDate,
		stateCode, // for the state that you want county data for, or false.
		currentMapSegmentSpan,
	} = params;

	return (dispatch, getState) => {

		const newMapSegmentSpan = currentMapSegmentSpan || getState().base.currentMapSegmentSpan;
		const { mapDataLoading } = getState().base;

		// Abort any pending requests for map data
		if (mapDataLoading) {
			abortMapDataFetch();
		}		
		mapDataAbortController = new AbortController();

		// Configure handler functions for fetch result
		const onReceive = (json) => {
			return dispatch(
				receiveMapData({
					data: json,
					narrative,
					perspective,
					filtersList,
					currentFilters,
					stateCode,
					fetchKey,
					currentMapSegmentSpan: newMapSegmentSpan,
				})
			)
		}		
		const onError = () => {
			return dispatch({type: RECEIVE_MAP_DATA_ERROR});
		}
		const onRetry = () => {
			dispatch({type: RECEIVE_MAP_DATA_RETRY});
		}

		// Set map loading state to true
		dispatch({type: MAP_DATA_LOADING});

		// Fetch the actual map data and process response
		return doFetchMapData({
			...params,
			abortController: mapDataAbortController,
			newMapSegmentSpan,
			dispatch,
			getState,
			notMOE: true,
			retryId: "mapDataRetryCount",
			onReceive,
			onError,
			onRetry,
		});
	};
};

export function submitSupportTicket(email, subject, text, logURL) {
	return (dispatch, getState) => {
		dispatch(submitSupportTicketInit());
		const { api, currentProject, authToken, userName } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const options = {
			method: "POST",
			mode: "cors",
			body: JSON.stringify({
				email,
				subject,
				text,
				logURL,
				project: `Narrative tracker: ${currentProject}`,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		};
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(api.support, options)
			.then((response) => response.json())
			.then((json) => dispatch(supportTicketSubmitResponse(json)))
			.catch((error, json) => {
				console.log(json);
				console.error(error);
			});
	};
};

// Fetches a single timeseries in the contecxt of fetching all timeseries.
export function fetchTimeseries(parameters) {
	const { currentFilters, endDate, dataType, fetchKey, filtersList, narrative, perspective, relevancy, startDate } = parameters;

	return (dispatch, getState) => {
		const staging = getState().base.stagingData;
		const { api, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { aiOnly, aiSupport } = getState().commonUI;
		const { percentageTypes, analystSystem, projectMapConfig, topicsPie, topicsPieArray, topicStatsConfig } = getState().projectConfig;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		const chartType = dataType ? dataType.id : "articleCount";

		const params = JSON.stringify({
			// aggregate: 7,
			ai: aiOnly,
			analystSystem,
			// FLAG_DISABLED_GRAPH_DATA_TYPE_SELECTOR_IN_REACTION
			chartType: perspective !== "Audience" ? chartType : "articleCount",
			endDate: endDate ? endDate.toString() : null,
			event: isThisAnEvent({ id: narrative.id, events: getState().events.eventTypes }),
			narrative: narrative.id,
			parent: narrative && narrative.parent,
			perspective,
			project: api.key,
			filters: formatFiltersForPost(alignPerspectiveOnLocationFilters(filtersList, perspective)),
			startDate: startDate ? startDate.toString() : null,
			relevancy,
			user: `${userName}_${userPool}`,
		});
		
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())

		return fetch(`${api.timeseries}?staging=${staging}`, {
			method: "POST",
			mode: "cors",
			body: params,
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => response.json())
			.then((json) => {
				if (topicsPie) {
					dispatch({ type: RECEIVE_TOPIC_STATS, data: JSON.parse(JSON.stringify(json)), narrative, topicsPieArray, topicStatsConfig });
				}
				return dispatch({
					type: "receiveTimeseries",
					data: json,
					aiOnly,
					aiSupport,
					fetchKey,
					filtersList,
					currentFilters,
					narrative,
					percentageTypes,
					perspective,
					projectMapConfig,
					dataType,
				});
			})
			.catch((error) => {
				console.error(error);
			});
	};
};

// Fetches a single timeseries for the graph tab
export function fetchGraphTabTimeseries(parameters) {
	const { narrative, perspective, filtersList, aiOverride } = parameters;
	// aiOverride should only exist if loading a share view
	// console.log(
	// 	"fetchGraphTabTimeseries",
	// 	narrative,
	// 	narrative.id,
	// 	narrative.index,
	// 	// perspective,
	// 	// startDate,
	// 	// endDate,
	// 	filtersList,
	// );

	return (dispatch, getState) => {
		const staging = getState().base.stagingData;
		const { api, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { aiOnly } = getState().commonUI;
		const { percentageTypes } = getState().projectConfig;
		const userPool = userData && userData.pool && userData.pool.userPoolId;

		const params = JSON.stringify({
			id: narrative.id,
			index: narrative.index,
			project: api.key,
			// interval: 7,
			filters: formatFiltersForPost(filtersList),
			ai: typeof aiOverride !== "undefined" ? aiOverride : aiOnly,
			user: `${userName}_${userPool}`,
		});
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(`${api.getTimeseries}?staging=${staging}`, {
			method: "POST",
			mode: "cors",
			body: params,
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
				// 'Access-Control-Allow-Origin': '*',
			},
		})
			.then((response) => response.json())
			.then((json) =>
				dispatch({
					type: "receiveGraphTabTimeseries",
					data: json,
					narrative,
					perspective,
					filtersList,
					percentageTypes,
				})
			)
			.catch((error) => {
				console.error(error);
			});
	};
};

// Compare mode:
// ----- Map data ------

let mapDataCompareLeftAbortController;
const abortMapDataCompareLeftFetch = () => {
	if (mapDataCompareLeftAbortController) {
		mapDataCompareLeftAbortController.abort();
	}
}
let mapDataCompareRightAbortController;
const abortMapDataCompareRightFetch = () => {
	if (mapDataCompareRightAbortController) {
		mapDataCompareRightAbortController.abort();
	}
}
export function fetchMapDataCompare(parameters) {
	// perspective: string. must be 'Audience' or 'Source'
	const {
		currentFilters,
		currentMapSegmentSpan,
		dmaAggregation,
		endDate,
		fetchKey,
		filtersList,
		narrative,
		notMOE,
		perspective,
		relevancy,
		startDate,
		stateCode,
		side,
	} = parameters;

	return (dispatch, getState) => {

		const newMapSegmentSpan = currentMapSegmentSpan || getState().base.currentMapSegmentSpan;
		const { mapDataLoading } = side === "Left" ? getState().leftCompare : getState().rightCompare;
		const { location } = getState().router;
		const eventMode = location && location.pathname === "/events";
		const thePerspective = eventMode ? "Source" : perspective;
		let theAborter;

		// Abort any pending requests for map data
		if (side === "Left") {
			if (mapDataLoading) {
				abortMapDataCompareLeftFetch();
			}		
			mapDataCompareLeftAbortController = new AbortController();
			theAborter = mapDataCompareLeftAbortController;
		}
		else {
			if (mapDataLoading) {
				abortMapDataCompareRightFetch();
			}		
			mapDataCompareRightAbortController = new AbortController();
			theAborter = mapDataCompareRightAbortController;
		}

		// Configure handler functions for fetch result
		const onReceive = (json) => {
			return dispatch(
				receiveMapDataCompare({
					currentFilters,
					currentMapSegmentSpan: newMapSegmentSpan,
					data: json,
					fetchKey,
					filtersList,
					narrative,
					notMOE,
					perspective,
					side,
					stateCode,
				})
			)
		}		
		const onError = () => {
			return dispatch({type: `${RECEIVE_MAP_DATA_ERROR}_${side}`});
		}
		const onRetry = () => {
			dispatch({type: `${RECEIVE_MAP_DATA_RETRY}_${side}`});
		}

		// Set map loading state to true
		dispatch({type: `requestMap${side}`});

		// Fetch the actual map data and process response
		return doFetchMapData({
			...parameters,
			abortController: theAborter,
			newMapSegmentSpan,
			dispatch,
			getState,
			perspective: thePerspective,
			retryId: "mapDataRetryCount",
			notMOE,
			onReceive,
			onError,
			onRetry,
		});
	};
};


// ------ Timeseries Data --------
export function fetchTimeseriesCompare(parameters) {
	const {
		correlationOnly,
		currentFilters,
		dataType,
		endDate,
		eventMode,
		fetchKey,
		filtersList,
		narrative,
		notMOE,
		parent,
		perspective,
		relevancy,
		side,
		startDate,
	} = parameters;
	// console.log(
	// 	"----> fetch Timeseries compare ===>",
	// 	// parameters
	// 	dataType,
	// 	perspective,
	// 	// filtersList,
	// 	// currentFilters,
	// 	// startDate,
	// 	// endDate,
	// 	// side
	// 	// notMOE,
	// 	// fetchKey
	// 	// eventMode
	// );

	return (dispatch, getState) => {
		const staging = getState().base.stagingData;
		const { location } = getState().router;
		const { api, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { aiOnly } = getState().commonUI;
		const { analystSystem } = getState().projectConfig;

		const userPool = userData && userData.pool && userData.pool.userPoolId;
		const chartType = dataType ? dataType.id : "articleCount";
		const eventTabMode = location && location.pathname === "/events";
		const thePerspective = eventTabMode ? "Source" : perspective;

		const body = notMOE
			? JSON.stringify({
					ai: aiOnly,
					analystSystem,
					// FLAG_DISABLED_GRAPH_DATA_TYPE_SELECTOR_IN_REACTION
					chartType: thePerspective !== "Audience" ? chartType : "articleCount",
					endDate: endDate ? endDate.toString() : null,
					event: isThisAnEvent({ id: narrative.id, events: getState().events.eventTypes }),
					filters: formatFiltersForPost(alignPerspectiveOnLocationFilters(filtersList, thePerspective)),
					narrative: narrative.id,
					parent: narrative.parent, // Force source for events
					perspective: thePerspective,
					project: api.key,
					relevancy,
					slice: 15,
					startDate: startDate ? startDate.toString() : null,
					user: `${userName}_${userPool}`,
			  })
			: JSON.stringify({
					ai: aiOnly,
					analystSystem,
					// FLAG_DISABLED_GRAPH_DATA_TYPE_SELECTOR_IN_REACTION
					chartType: thePerspective !== "Audience" ? chartType : "articleCount",
					endDate: endDate ? endDate.toString() : null,
					event: isThisAnEvent({ id: narrative.id, events: getState().events.eventTypes }),
					filters: formatFiltersForPost(alignPerspectiveOnLocationFilters(filtersList, thePerspective)),
					moe: narrative.id,
					parent: narrative.parent,
					perspective: thePerspective,
					project: api.key,
					relevancy,
					startDate: startDate ? startDate.toString() : null,
					slice: 15,
					user: `${userName}_${userPool}`,
			  });

		const params = {
			method: "POST",
			mode: "cors",
			body,
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		};
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(`${api.timeseries}?staging=${staging}`, params)
			.then((response) => response.json())
			.then((json) => {
				if (!correlationOnly) {
					dispatch(
						receiveTimeseriesCompare({
							data: json,
							dataType,
							narrative,
							perspective: thePerspective,
							filtersList,
							currentFilters,
							side,
							fetchKey,
							parent,
						})
					);
				}
				if (eventMode) {
					dispatch(
						fetchCorrelation({
							data: json,
							id: narrative.id,
							fetchKey,
						})
					);
				}
			})
			.catch((error, json) => {
				console.error(error);
				console.log("fetchTimeseriesCompare error details", json);
			});
	};
};

let compareArticlesAbortController = {
	Left: null,
	Right: null
};
const abortCompareArticlesFetch = (side) => {
	if (compareArticlesAbortController[side]) {
		compareArticlesAbortController[side].abort();
	}
}

function doFetchCompareArticles(parameters) {
	const {
		adjustForAggregation = false,
		dispatch,
		getState,
		ascending,
		currentFilters,
		endDate,
		fetchKey,
		filtersList,
		narrative,
		perspective,
		relevancy,
		showDuplicates,
		side,
		sortBy,
		startDate,
		pageLength,
		offset,
	} = parameters;

	const staging = getState().base.stagingData;
	const { location } = getState().router;
	const { analystSystem } = getState().projectConfig;
	const { aiOnly } = getState().commonUI;
	const { api, userData, userName, authToken } = getState().login;
	const { 
		aggregationLevel,
		articlesFetchingRetryCount,
	} = side === "Left" ? getState().leftCompare : getState().rightCompare;
	
	const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
	const backupShowDuplicates = getState().base.showDuplicates;
	const eventMode = location && location.pathname === "/events";
	const thePerspective = eventMode ? "Source" : perspective;
	const filters = formatFiltersForPost(alignPerspectiveOnLocationFilters(filtersList, thePerspective));
	const userPool = userData && userData.pool && userData.pool.userPoolId;

	compareArticlesAbortController[side] = new AbortController();
	// forcibly refresh tokens
	Auth.currentSession().catch(() => dispatchTokenFailure())
	return fetch(`${api.articles}?staging=${staging}`, {
		method: "POST",
		signal: compareArticlesAbortController[side].signal,
		mode: "cors",
		body: JSON.stringify({
			ai: aiOnly,
			analystSystem,
			asc: ascending,
			desc: !ascending,
			endDate: endDate || Date.now(),
			event: isThisAnEvent({ id: narrative.id, events: getState().events.eventTypes }),
			filters,
			narrative: (narrative && (narrative.id !== "narratives")) ? narrative.id : null,
			perspective: thePerspective,
			project: api.key,
			parent: narrative.parent,
			relevancy,
			showDuplicates: typeof showDuplicates === "undefined" ? backupShowDuplicates : showDuplicates,
			slice: 15,
			sort: [sortBy],
			startDate: adjustForAggregation 
				? adjustStartDateForAggregation({startDate, aggregationLevel}).toString() 
				: startDate,
			user: `${userName}_${userPool}`,
			pageLength: pageLength || CONTENT_PAGE_LENGTH,
			offset: offset || 0,
		}),
		headers: {
			"Content-Type": "application/json",
			Authorization: idToken,
		},
	})
	.then((response) => {
		if (!response.ok) {
			throw new Error(SERVER_ERROR);
		}
		return response.json()
	})
	.then((json) => {
		return dispatch(
			receiveCompareArticles({
				articles: json,
				narrative,
				perspective,
				filtersList,
				currentFilters,
				side,
				fetchKey,
			})
		)
	})
	.catch((error) => {
		if (error.name === 'AbortError') {
			// No action needed
			console.log(`Compare Article ${side} fetch request aborted`);
		}
		else if (articlesFetchingRetryCount >= FETCH_RETRY_MAX) {
			console.error(error);
			dispatch({type: `${RECEIVE_ARTICLES_ERROR}_${side}`});
		}
		else {
			console.warn(`${error} - Retry attempt ${articlesFetchingRetryCount + 1}...`);
			dispatch({type: `${RECEIVE_ARTICLES_RETRY}_${side}`});
			doFetchCompareArticles(parameters);
		}
	})
}

export function fetchCompareArticles(parameters) {
	const {
		ascending,
		currentFilters,
		endDate,
		fetchKey,
		filtersList,
		narrative,
		perspective,
		showDuplicates,
		relevancy,
		side,
		sortBy,
		startDate,
		pageLength,
		offset,
	} = parameters;

	if (!startDate || !endDate) {
		console.warn("Dates missing from fetchCompareArticles()", startDate, endDate);
	}
	return (dispatch, getState) => {
		const narrativeId = narrative.id !== "narratives" ? narrative.id : null;
		const {	articlesFetching } = side === "Left" ? getState().leftCompare : getState().rightCompare;

		if (articlesFetching) {
			abortCompareArticlesFetch(side);
		}

		dispatch({ type: `requestArticles${side}`, narrativeId });

		return doFetchCompareArticles({
			dispatch,
			getState,
			ascending,
			currentFilters,
			endDate,
			fetchKey,
			filtersList,
			narrative,
			perspective,
			relevancy,
			showDuplicates,
			side,
			sortBy,
			startDate,
			pageLength,
			offset,
		});
	};
};

export function fetchCompareEntities(parameters) {
	const {
		adjustForAggregation = false,
		currentFilters,
		endDate,
		fetchKey,
		filtersList,
		narrative,
		perspective,
		relevancy,
		side,
		startDate,
		translateEntities,
	} = parameters;
	// console.log('----> fetchCompareEntities', side, startDate, endDate);
	return (dispatch, getState) => {
		const staging = getState().base.stagingData;
		const { aggregationLevel } = side === "Left" ? getState().leftCompare : getState().rightCompare;
		const { api, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { aiOnly } = getState().commonUI;
		const { analystSystem } = getState().projectConfig;
		const narrativeId = narrative.parent === "self" ? undefined : narrative.id;
		const userPool = userData && userData.pool && userData.pool.userPoolId;

		if (!aiOnly) {
			// forcibly refresh tokens
			Auth.currentSession().catch(() => dispatchTokenFailure())
			return fetch(`${api.entities}?staging=${staging}`, {
				method: "POST",
				mode: "cors",
				body: JSON.stringify({
					ai: aiOnly,
					analystSystem,
					endDate,
					event: isThisAnEvent({ id: narrativeId, events: getState().events.eventTypes }),
					filters: formatFiltersForPost(filtersList),
					max: 500,
					narrative: narrativeId,
					parent: narrative.parent,
					perspective,
					project: api.key,
					relevancy,
					slice: 15,
					startDate: adjustForAggregation 
						? adjustStartDateForAggregation({startDate, aggregationLevel}).toString() 
						: startDate,	
					translateEntities,
					user: `${userName}_${userPool}`,
				}),
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			})
				.then((response) => response.json())
				.then((json) =>
					dispatch(
						receiveCompareEntities({
							data: json,
							narrative,
							perspective,
							filtersList,
							currentFilters,
							side,
							fetchKey,
						})
					)
				)
				.catch((error) => {
					console.error(error);
				});
		}
	};
};


// --- Media Tab ---

// Fetch All filters
export const fetchMediaFilters = () => {
	return (dispatch, getState) => {
		const { api, userData, userName, authToken } = getState().login;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
	
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(`${api.mediaFilters}`, {
			method: "POST",
			mode: "cors",
			body: JSON.stringify({
				project: api.key,
				userName,
				userPool,
				user: `${userName}_${userPool}`,
				mediaTab: true,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
				// 'Access-Control-Allow-Origin': '*',
			},
		})
			.then((response) => response.json())
			.then((json) => {
				let apiFilters = Array.isArray(json) ? json : Object.values(json);
				if (!Array.isArray(apiFilters)) {
					apiFilters = [];
				}
				decorateFilters(apiFilters);				
				dispatch({type: RECEIVE_MEDIA_FILTERS, filters: apiFilters})
				// Get any child filters for dynamic filters which have an initial "open" status
				for (let i=0; i<apiFilters.length; i++) {
					if (apiFilters[i].type === DYNAMIC_FILTER_TYPE && apiFilters[i].status === "open") {
						dispatch(fetchMediaDynamicFilters(apiFilters[i]));
					}
				}
			})
			.catch((error) => {
				console.error("RECEIVE_MEDIA_FILTERS error", error);
			});
	};
};

// Fetch dynamic filters

const dynamicFilterAbortControllers = {};
const abortDynamicFiltersFetch = (filterId) => {
	if (dynamicFilterAbortControllers[filterId]) {
		dynamicFilterAbortControllers[filterId].abort();
		delete dynamicFilterAbortControllers[filterId];
	}
}
export const fetchMediaDynamicFilters = (filter) => {
	if (!filter.fieldName || filter.status !== "open") {
		return () => {};
	}
	return (dispatch, getState) => {
		const { 
			activeSearchTranslationEnabled, 
			activeSearchTranslationLanguages, 
			activeSearchObj, 
			currentFiltersList,
			currentZoom, 
			filters, 
		} = getState().media;
		const { api, userData, userName, authToken } = getState().login;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const formattedFilters = formatHierarchyFiltersForPost(filters);
		const queryAdds = formatQueryAddsForPost(currentFiltersList);
		const queryExcludes = formatQueryExcludesForPost(currentFiltersList);

		const query = activeSearchObj && activeSearchObj.query && activeSearchObj.query.length > 0
			? activeSearchObj.query
			: undefined;

		const fieldSearch = filter.filterFilterString && filter.filterFilterString.length > 0
			? filter.filterFilterString
			: undefined;

		if (filter.isLoading) {
			abortDynamicFiltersFetch(filter.id);
		}
		dynamicFilterAbortControllers[filter.id] = new AbortController();

		dispatch({ type: FETCHING_MEDIA_DYNAMIC_FILTERS, parentFilter: filter })

		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure());

		// Fetch the filters and process response
		return fetch(`${api.dynamicMediaFilters}`, {
			method: "POST",
			signal: dynamicFilterAbortControllers[filter.id].signal,
			mode: "cors",
			body: JSON.stringify({
				project: api.key,
				userName,
				userPool,
				user: `${userName}_${userPool}`,
				mediaTab: true,
				fieldName: filter.fieldName,
				fieldSearch,
				query,
				queryExpand: activeSearchTranslationEnabled,
				queryExpandLang: activeSearchTranslationLanguages,
				filters: formattedFilters,
				queryAdd: queryAdds,
				queryExclude: queryExcludes,
				size: MAX_DYNAMIC_FILTERS, 
				startDate: currentZoom.begin,
				endDate: currentZoom.end,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error(SERVER_ERROR);
				}
				return response.json()
			})
			.then((json) => {
				const results = json.data;
				for (let i=0; i<results.length; i++) {
					results[i].type = DYNAMIC_FILTER_RESULT_TYPE
					results[i].parent = filter.id
					results[i].parentId = filter.id
					results[i].parentDisplayName = filter.name
				}
				dispatch({ type: RECEIVE_MEDIA_DYNAMIC_FILTERS, newChildren: results, parentFilter: filter });
				if(dynamicFilterAbortControllers[filter.id]) {
					delete dynamicFilterAbortControllers[filter.id];
				}
			})
			.catch((error) => {
				if (error.name === 'AbortError') {
					// No action needed
				}
				else {
					dispatch({ type: RECEIVE_MEDIA_DYNAMIC_FILTERS_ERROR, filter});
				}
				if(dynamicFilterAbortControllers[filter.id]) {
					delete dynamicFilterAbortControllers[filter.id];
				}
			});
	};
};

// Fetch Articles (media tab) 
let mediaArticlesAbortController;
const abortMediaArticlesFetch = () => {
	if (mediaArticlesAbortController) {
		mediaArticlesAbortController.abort();
	}
}

export function doFetchMediaArticles(params) {
	const {
		activeSearchTranslationEnabled,
		activeSearchTranslationLanguages,
		ascending,
		begin,
		country,
		dispatch,
		end,
		getState,
		offset,
		pageLength,
		query,
		lang,
		searchObj,
		setup,
		showTranslate,
		sortBy,
	} = params;
	const { api, authToken, userName } = getState().login;
	const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
	const { 
		outletFilters, 
		aggregationLevel,
		articlesLoadingRetryCount, 
		filters, 
		currentFiltersList,
		contentFilteredByDate,
		currentZoom,
	} = getState().media;
	// const filters = [{ entities: outletFilters.length > 0 ? outletFilters : [] }, { keywords: [query] }];
	const formattedFilters = formatHierarchyFiltersForPost(filters);
	const queryAdds = formatQueryAddsForPost(currentFiltersList);
	const queryExcludes = formatQueryExcludesForPost(currentFiltersList);
	const queryToSend = (query && query.length > 0) ? query : undefined;

	// forcibly refresh tokens
	Auth.currentSession().catch(() => dispatchTokenFailure())
	mediaArticlesAbortController = new AbortController();

	return (
		fetch(`${api.getMediaContent}`, {
			method: "POST",
			signal: mediaArticlesAbortController.signal,
			mode: "cors",
			body: JSON.stringify({
				asc: ascending,
				debug: searchObj,
				desc: !ascending,
				endDate: end || null,
				index: searchObj.index,
				language: lang === "All" ? "All" : lang,
				project: api.dataKey,
				country,
				query: queryToSend,
				queryExpand: activeSearchTranslationEnabled,
				queryExpandLang: activeSearchTranslationLanguages,
				queryAdd: queryAdds,
				queryExclude: queryExcludes,
				filters: formattedFilters,
				sort: [sortBy],
				sourceState: searchObj.sourceState,
				startDate: begin 
					|| (contentFilteredByDate 
								? adjustStartDateForAggregation({startDate: currentZoom.begin, aggregationLevel})
								: currentZoom.begin
							)
					|| null,
				translate: showTranslate,
				type: searchObj.type,
				tab: "mediaTab",
				pageLength,
				offset,
				// HIDING_FOR_NOW
				// garbage: showGarbage,
				// hidden: showHidden,
				// international: showInternational,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
				// 'Access-Control-Allow-Origin': '*',
			},
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error(SERVER_ERROR);
				}
				return response.json()
			})
			.then((json) => {
				const resBegin = begin || json.startDate;
				const resEnd = end || json.endDate;
				dispatch({
					type: RECEIVE_MEDIA_ARTICLES,
					articles: json.articles,
					expandedQuery: json.expandedQuery,
					headers: json.headers,
					setup: !!setup,
					fetchKey: `${searchObj.id}_${searchObj.lang || "noLang"}_${searchObj.locationStr || "noLocation"}_${resBegin}to${resEnd}`,
				})
			})
			.catch((error) => {
				if (error.name === 'AbortError') {
					// No action needed
					// console.log('Media article fetch request aborted');
				}
				else if (articlesLoadingRetryCount >= FETCH_RETRY_MAX) {
					console.error(error);
					dispatch({type: RECEIVE_MEDIA_ARTICLES_ERROR});
				}
				else {
					console.warn(`${error} - Retry attempt ${articlesLoadingRetryCount + 1}...`);
					dispatch({type: RECEIVE_MEDIA_ARTICLES_RETRY});
					doFetchMediaArticles(params, lang, country, dispatch, getState);
				}
			})
	);
}

export function fetchMediaArticles(params) {
	const {
		searchObj,
		useSearchObj,
		pageLength, 
		offset
	} = params;
	return (dispatch, getState) => {
		const { 
			selectedLanguage, 
			selectedCountry, 
			articlesLoading,
			activeSearchTranslationEnabled,
			activeSearchTranslationLanguages,
		} = getState().media;
		const lang = useSearchObj ? searchObj.lang : selectedLanguage;
		const country = useSearchObj ? searchObj.country : selectedCountry;
		if (articlesLoading) {
			abortMediaArticlesFetch();
		}
		dispatch({ type: FETCHING_MEDIA_ARTICLES });
		dispatch({
			type: SYNC_LANGUAGES,
			payload: {
				currentLanguage: lang,
				selectedLanguage: lang,
			},
		});
		dispatch({
			type: SYNC_COUNTRIES,
			payload: {
				currentCountry: country,
				selectedCountry: country,
			},
		});
		return doFetchMediaArticles({
			...params, 
			lang, 
			country, 
			pageLength, 
			offset, 
			activeSearchTranslationEnabled,
			activeSearchTranslationLanguages,
			dispatch, 
			getState
		}) ;
	};
};

// Fetch Single Article (media tab) 
export function fetchMediaData(article) {
	return (dispatch, getState) => {
		const { api, userEmail, authToken, userName } = getState().login;
		const { activeSearchObj, articlesExpandedQuery } = getState().media;
		const queryString = articlesExpandedQuery || (activeSearchObj ? activeSearchObj.query : "");
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { distractionFreeDeveloperMode } = getState().commonUI;
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(`${api.singleArticle}?id=${article.id}&index=${article.index}&search=${article.search}&email=${userEmail}&query=${queryString}`, {
			method: "GET",
			mode: "cors",
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => response.json())
			.then((json) =>
				dispatch({
					type: "receiveArticleData",
					data: json,
					narratives: getState().base.flatNarratives,
					id: article.id,
					index: article.index,
					distractionFreeDeveloperMode,
				})
			)
			.catch((error) => {
				console.error(error);
			});
	};
};

// Fetch Timeseries (media tab) 
let mediaTimeseriesAbortController;
const abortMediaTimeseriesFetch = () => {
	if (mediaTimeseriesAbortController) {
		mediaTimeseriesAbortController.abort();
	}
}
export function fetchMediaTimeseries(parameters) {
	const { query, id, lang, name, locationStr } = parameters.searchObj;
	return (dispatch, getState) => {
		const { api, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { 
			activeSearchTranslationEnabled,
			activeSearchTranslationLanguages,
			currentZoom, 
			selectedLanguage, 
			selectedCountry, 
			outletFilters, 
			filters, 
			currentFiltersList, 
			lineLoading, 
			timeseriesLoadingRetryCount 
		} = getState().media;
		// const formattedFilters = [{ entities: outletFilters.length > 0 ? outletFilters : [] }, { keywords: [query] }];
		const formattedFilters = formatHierarchyFiltersForPost(filters);
		const queryAdds = formatQueryAddsForPost(currentFiltersList);
		const queryExcludes = formatQueryExcludesForPost(currentFiltersList);
		const queryToSend = (query && query.length > 0) ? query : undefined;

		const params = JSON.stringify({
			query: queryToSend,
			project: api.key,
			language: selectedLanguage,
			country: selectedCountry,
			filters: formattedFilters,
			queryAdd: queryAdds,
			queryExclude: queryExcludes,
			queryExpand: activeSearchTranslationEnabled,
			queryExpandLang: activeSearchTranslationLanguages,
			tab: "mediaTab",
			startDate: currentZoom.begin,
			endDate: currentZoom.end,
		});

		if (lineLoading) {
			abortMediaTimeseriesFetch();
		}
		mediaTimeseriesAbortController = new AbortController();
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		// console.log("fetchMediaTimeSeries - ", params);
		return fetch(`${api.getMediaTimeseries}`, {
			method: "POST",
			signal: mediaTimeseriesAbortController.signal,
			mode: "cors",
			body: params,
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
				// 'Access-Control-Allow-Origin': '*',
			},
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error(SERVER_ERROR);
				}
				return response.json()
			})
			.then((json) => {
				// console.log("getMediaTimeseries - response - ", json);
				json.id = json.id || id;
				json.name = json.name || name;

				const lines = assignStaticColor({ list: [json], colors });
				const keys = Object.keys(lines[0].timeseries);
				const rangeStart = Number(keys[0]);
				const rangeEnd = Number(keys[keys.length - 1]);
				// json.color = {
				// 	id: "Blue",
				// 	dark: "#0074E4",
				// 	darkChild: "#17588e",
				// 	light: "#0074E4",
				// 	lightChild: "#17588e",
				// 	colorblind: "colorblindDashed",
				// 	inUse: 0,
				// };
				dispatch({
					type: RECEIVE_MEDIA_TIMESERIES,
					lines,
					query,
					fetchKey: `${id}_${lang || "noLang"}_${locationStr || "noLocation"}_${rangeStart}to${rangeEnd}`,
				});
			})
			.catch((error, json) => {
				if (error.name === 'AbortError') {
					// No action needed
				}
				else if (timeseriesLoadingRetryCount >= FETCH_RETRY_MAX) {
					console.error(error);
					dispatch({type: RECEIVE_MEDIA_TIMESERIES_ERROR,	data: json});
				}
				else {
					console.warn(`${error} - Retry attempt ${timeseriesLoadingRetryCount + 1}...`);
					dispatch({type: RECEIVE_MEDIA_TIMESERIES_RETRY});
					dispatch(fetchMediaTimeseries(parameters));
				}
			});
	};
};

// Fetch Timeseries to Compare (media tab) 
export const fetchMediaTimeseriesToCompare = (searchObj) => {
	const { query, id, name } = searchObj;

	return (dispatch, getState) => {
		const { api, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { 
			activeSearchTranslationEnabled,
			activeSearchTranslationLanguages,
			currentZoom, 
			selectedLanguage, 
			selectedCountry, 
			filters, 
			currentFiltersList, 
			outletFilters,
		} = getState().media;
		// const filters = [{ entities: outletFilters.length > 0 ? outletFilters : [] }, { keywords: [query] }];
		const formattedFilters = formatHierarchyFiltersForPost(filters);
		const queryAdds = formatQueryAddsForPost(currentFiltersList);
		const queryExcludes = formatQueryExcludesForPost(currentFiltersList);
		const queryToSend = (query && query.length > 0) ? query : undefined;

		const params = JSON.stringify({
			query: queryToSend,
			project: api.key,
			language: selectedLanguage,
			filters : formattedFilters,
			queryAdd: queryAdds,
			queryExclude: queryExcludes,
			queryExpand: activeSearchTranslationEnabled,
			queryExpandLang: activeSearchTranslationLanguages,
			country: selectedCountry,
			tab: "mediaTab",
			startDate: currentZoom.begin,
			endDate: currentZoom.end,
		});
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(`${api.getMediaTimeseries}`, {
			method: "POST",
			mode: "cors",
			body: params,
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
				// 'Access-Control-Allow-Origin': '*',
			},
		})
			.then((response) => response.json())
			.then((json) => {
				json.id = json.id || id;
				json.name = json.name || name;
				dispatch({
					type: ADD_MEDIA_TIMESERIES,
					line: json,
					query,
				});
			})
			.catch((error) => {
				console.error(error);
			});
	};
};

let mediaEntitiesAbortController;
const abortMediaEntitiesFetch = () => {
	if (mediaEntitiesAbortController) {
		mediaEntitiesAbortController.abort();
	}
}
// Fetch Entities (media tab) 
export function fetchMediaEntities(parameters) {
	const {
		begin,
		end,
	} = parameters;

	return (dispatch, getState) => {
		const staging = getState().base.stagingData;
		const { api, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { aiOnly } = getState().commonUI;
		const { analystSystem, defaultEntityType, mediaEntityFilters } = getState().projectConfig;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		const { 
			activeSearchObj, 
			activeSearchTranslationEnabled,
			activeSearchTranslationLanguages,
			selectedLanguage, 
			selectedCountry, 
			filters, 
			currentFiltersList, 
			outletFilters, 
			entitiesFetching, 
			entitiesFetchingRetryCount,
		} = getState().media;
		// const lang = useSearchObj ? searchObj.lang : selectedLanguage;
		// const country = useSearchObj ? searchObj.country : selectedCountry;
		// const filters = [{ entities: outletFilters.length > 0 ? outletFilters : [] }, { keywords: [query] }];
		const formattedFilters = formatHierarchyFiltersForPost(filters);
		const queryAdds = formatQueryAddsForPost(currentFiltersList);
		const queryExcludes = formatQueryExcludesForPost(currentFiltersList);

		const query = activeSearchObj && activeSearchObj.query && activeSearchObj.query.length > 0
			? activeSearchObj.query
			: undefined;

		// const filters = [{ keywords: [query] }];
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())

		// FLAG_DISABLE_MEDIA_ENTITIES
		if (!mediaEntityFilters) {
			// console.log("fetchMediaEntities has been disabled - FLAG_DISABLE_MEDIA_ENTITIES");
			return;
		}

		if (entitiesFetching) {
			abortMediaEntitiesFetch();
		}

		const body = JSON.stringify({
			ai: aiOnly,
			analystSystem,
			endDate: end,
			event: false,
			filters: formattedFilters,
			query,
			queryAdd: queryAdds,
			queryExclude: queryExcludes,
			queryExpand: activeSearchTranslationEnabled,
			queryExpandLang: activeSearchTranslationLanguages,
			language: selectedLanguage,
			country: selectedCountry,
			// parent: narrative.parent,
			perspective: "Source",
			project: api.key,
			max: 500,
			// narrative: narrativeId,
			relevancy: 0.65,
			slice: 15,
			startDate: begin,
			tab: "mediaTab",
			user: `${userName}_${userPool}`,
		});

		if (!aiOnly) {
			mediaEntitiesAbortController = new AbortController();
			return fetch(`${api.entities}?staging=${staging}`, {
				method: "POST",
				signal: mediaEntitiesAbortController.signal,
				mode: "cors",
				body,
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			})
				.then((response) => {
					if (!response.ok) {
						throw new Error(SERVER_ERROR);
					}
					return response.json()
				})
				.then((json) => {
					dispatch({
						type: RECEIVE_MEDIA_ENTITIES,
						data: json,
						defaultEntityType,
					});
				})
				.catch((error, json) => {
					if (error.name === 'AbortError') {
						// No action needed
					}
					else if (entitiesFetchingRetryCount >= FETCH_RETRY_MAX) {
						console.error(error);
						dispatch({type: RECEIVE_MEDIA_ENTITIES_ERROR,	data: json});
					}
					else {
						console.warn(`${error} - Retry attempt ${entitiesFetchingRetryCount + 1}...`);
						dispatch({type: RECEIVE_MEDIA_ENTITIES_RETRY});
						dispatch(fetchMediaEntities(parameters));
					}
				});
		}
	};
};

// Fetch project searches (media tab) 
export function fetchSearchList() {
	return (dispatch, getState) => {
		const { api, authToken, userName } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(`${api.listMediaSearches}?key=${api.dataKey}`, {
			method: "GET",
			mode: "cors",
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => response.json())
			.then((json) => {
				const parsedSearches = json.map(x => {
					return {
						...x,
						additionalAttributes: JSON.parse(x.additionalAttributes || "{}")
					}
				});
				dispatch({
					type: RECEIVE_SEARCH_LIST,
					searches: parsedSearches,
				})
			})
			.catch((error, json) => {
				console.log(json);
				console.error(error);
			});
	};
}

const getDefaultSearch = (searchList, searchType, project) => {
	return searchList.find(x => {
		return x.searchType === searchType 
			&& x.additionalAttributes?.isDefault === true
			&& x.project === project;
	});
}

// Fetch user searches (media tab) 
export const fetchUserSearches = (params) => {
	const { userId, selectSearch } = params;
	return (dispatch, getState) => {
		const { api, userName, authToken } = getState().login;
		const { noUserSearches } = getState().projectConfig;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		if (!noUserSearches) {
			return fetch(`${api.userSearches}/${userId}`, {
				method: "GET",
				mode: "cors",
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			})
				.then((response) => response.json())
				.then((json) => {
					// REVISIT JA: API is returning search's additionalAttributes property
					// as a string which is not in JSON format so we hack it here to turn 
					// it into a usable object, we should really fix the API for this
					const parsedSearches = json.payload && json.payload.map(x => {
						const hasAdditionalAttribs = x.additionalAttributes?.length > 0;
						try {
							const hackedAttribString = !hasAdditionalAttribs ? "" : x.additionalAttributes
								.replace(/{/g, '{"')
								.replace(/=/g, '": ');
							return {
								...x,
								additionalAttributes: JSON.parse(hasAdditionalAttribs ? hackedAttribString : "{}")
							}
						}
						catch {
							return {
								...x,
							}
						}
					});
					// Store the received user searches
					dispatch({ type: RECEIVE_USER_SEARCHES, searches: parsedSearches, key: api.key });
					// Apply the default search (if one exists)
					if (parsedSearches) {
						const defaultMediaSearch = getDefaultSearch(parsedSearches, "media", api.key);
						if (defaultMediaSearch) {
							dispatch(selectSearch(defaultMediaSearch));
						}
					}
				})
				.catch((error) => {
					console.error("fetchUserSearches error", error);
				});
		}
	};
};

// Delete user search (media / data explorer tabs) 
export const deleteUserCreatedSearch = (params) => {
	const { id, userId, searchType } = params;

	const deleteActionType = 
		searchType === "dataExplorer" ? DELETE_DATA_EXPLORER_USER_CREATED_SEARCH
			: searchType === "media" ? PROACTIVELY_DELETE_USER_CREATED_SEARCH
			: PROACTIVELY_DELETE_USER_CREATED_SEARCH;	
	const closeModalActionType = 
		searchType === "dataExplorer" ? CLOSE_DATA_EXPLORER_DELETE_SEARCH_MODAL
			: searchType === "media" ? CLOSE_DELETE_SEARCH_MODAL
			: CLOSE_DELETE_SEARCH_MODAL;	
	const addSearchActionType = 
		searchType === "dataExplorer" ? ADD_DATA_EXPLORER_USER_CREATED_SEARCH
			: searchType === "media" ? ADD_USER_CREATED_SEARCH
			: ADD_USER_CREATED_SEARCH;

	return (dispatch, getState) => {
		const { api, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		dispatch({ type: deleteActionType, search: params });
		dispatch({ type: closeModalActionType });
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(`${api.userSearches}`, {
			method: "DELETE",
			mode: "cors",
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
			body: JSON.stringify({
				userId,
				id,
			}),
		})
			.then((response) => response.json())
			.then((json) => {
				// No action required
			})
			.catch((error) => {
				console.error("deleteUserCreatedSearch error", error);
				dispatch({ type: addSearchActionType, search: params });
			});
	};
};


const processMediaSaveSearchReponse = (params) => {
	const { 
		dispatch, 
		editingActiveSearch,
		editingUserSearch,
		activeSearchObj,
		newSearch,
	} = params;

	dispatch({
		type: ADD_USER_CREATED_SEARCH,
		search: newSearch,
	});
	// if (editingActiveSearch) {
	// 	const newActiveSearch = activeSearchObj.query ? activeSearchObj.query : newSearch.query; // keep old activesearch as we wont re-execute a search now 
	// 	dispatch({ type: SET_MEDIA_ACTIVE_SEARCH, searchObj: newSearch, activeSearch: newActiveSearch});
	// 	dispatch({ type: UPDATE_MEDIA_SEARCH_INPUT, value: newSearch.query });
	// }
	dispatch({ type: SAVE_USER_SUCCESS });
	setTimeout(() => {
		dispatch({ type: CLOSE_CREATE_SEARCH_MODAL });
	}, 1000);
}

const processDataExplorerSaveSearchResponse = (params) => {
	const { 
		dispatch, 
		editingActiveSearch,
		editingUserSearch,
		activeSearchObj,
		newSearch,
	} = params;

	dispatch({
		type: ADD_DATA_EXPLORER_USER_CREATED_SEARCH,
		search: newSearch,
	});
	// if (editingActiveSearch) {
	// 	const newActiveSearch = activeSearchObj.query ? activeSearchObj.query : newSearch.query; // keep old activesearch as we wont re-execute a search now 
	// 	dispatch({ type: SET_DATA_EXPLORER_SEARCH, searchObj: newSearch, activeSearch: newActiveSearch});
	// 	dispatch({ type: UPDATE_DATA_EXPLORER_SEARCH_INPUT, value: newSearch.query });
	// }
	dispatch({ type: DATA_EXPLORER_SAVE_USER_SEARCH_SUCCESS });
	setTimeout(() => {
		dispatch({ type: CLOSE_DATA_EXPLORER_CREATE_SEARCH_MODAL });
	}, 1000);
}

const processSavedSearchResponse = (params) => {
	const { 
		json, 
		search, 
		searchType, 
	} = params;

	const newSearch = {
		id: json ? json.id : "failedId",
		locationStr: search.locationStr,
		name: search.name,
		project: search.project,
		query: allQuotesDoubleTemporary(search.query),
		searchType,
		userId: search.userId,
		additionalAttributes: search.additionalAttributes,
	};

	switch(searchType) {
		case "media": processMediaSaveSearchReponse({...params, newSearch}); break;
		case "dataExplorer": processDataExplorerSaveSearchResponse({...params, newSearch}); break;
		default: break;
	}
}

const getSavedSearchErrorAction = (searchType) => {
	switch(searchType) {
		case "media": return SAVE_USER_SEARCH_ERROR;
		case "dataExplorer": return DATA_EXPLORER_SAVE_USER_SEARCH_ERROR;
		default: return null;
	}
}
const getSavedSearchSpinnerAction = (searchType) => {
	switch(searchType) {
		case "media": return SAVE_USER_SEARCH_SPINNER;
		case "dataExplorer": return DATA_EXPLORER_SAVE_USER_SEARCH_SPINNER;
		default: return null;
	}
}

// Save user search (media tab) 
export const saveUserSearch = (params) => {
	return (dispatch, getState) => {
		const { api, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { createSearchLocation, isDefault, createSearchName, createSearchQuery, editingUserSearch, searchType } = params;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		const userId = `${userName}_${userPool}`;
		const { activeSearchObj } = getState()[searchType];
		dispatch({ type: getSavedSearchSpinnerAction(searchType) });

		const editingActiveSearch = (activeSearchObj.id === editingUserSearch);
		const search = {
			userId,
			query: allQuotesSingle(createSearchQuery),
			name: createSearchName,
			locationStr: createSearchLocation || "none",
			project: api.key,
			searchType,
			additionalAttributes: {isDefault: isDefault || false},
			global: false, // this can't be null, must be an actual boolean
		};
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(`${api.userSearches}`, {
			method: "POST",
			mode: "cors",
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
			body: JSON.stringify(search),
		})
			.then((response) => response.json())
			.then((json) => {
				// Update the newly saved search
				processSavedSearchResponse({ 
					dispatch, 
					json, 
					search, 
					searchType, 
					editingActiveSearch,
					editingUserSearch,
					activeSearchObj
				});
				// If this isn't a brand new search, delete the old one
				if (editingUserSearch) {
					dispatch(deleteUserCreatedSearch({ id: editingUserSearch, userId, searchType }));
				}
			})
			.catch((error) => {
				console.error("saveUserCreatedSearch error", error);
				dispatch({
					type: getSavedSearchErrorAction(searchType),
					createSearchSpinner: false,
					saveUserSearchError: true,
				});
			});
	};
};


// --- Social Media Tab ---

export function fetchSocialMediaData(article) {
	return (dispatch, getState) => {
		const { api, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { distractionFreeDeveloperMode } = getState().commonUI;
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		// console.log("fetchSocialMediaData - ", article.id);
		//https://rest-api.exovera-projects.com/ev3/getdocument?id=151:WECHAT:BfQ0gJJ9xyHmCQOKayMaXRRIjraVGl&index=ev3socialau&type=wechat
		return fetch(`${api.singleArticle}?id=${article.id}&index=${article.index}&type=${article.type}`, {
			method: "GET",
			mode: "cors",
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => response.json())
			.then((json) => {
				json.exoveraId = article.id;
				//json["unsafe"] = false;
				dispatch({
					type: "receiveArticleData",
					data: json,
					narratives: getState().base.flatNarratives,
					id: article.id,
					index: article.index,
					distractionFreeDeveloperMode,
				});
			})
			.catch((error) => {
				console.error(error);
			});
	};
};


// --- Reports Tab ---
export function fetchReports(params) {
	const {
		ascending,
		begin,
		end,
		query,
		searchObj,
		sortBy,
		// useSearchObj,
	} = params;

	return (dispatch, getState) => {
		const { api, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const queryToSend = (query && query.length > 0) ? query : undefined;
		// const { selectedLanguage } = getState().media;
		// const lang = useSearchObj ? searchObj.lang : selectedLanguage;

		dispatch({ type: FETCHING_REPORTS, payload: { reportsLoading: true } });

		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())

		return fetch(api.getReports, {
			method: "POST",
			mode: "cors",
			body: JSON.stringify({
				asc: ascending,
				debug: searchObj,
				desc: !ascending,
				endDate: end || null,
				// TODO: UNMOCK: THIS
				// project: "politics2020-c4c66e01afca57f4896cd084f0c73df0",
				// query: "climate change",
				project: api.key,
				query: queryToSend,
				searchId: "thisIsAnId", // null breaks the API
				sort: sortBy || "pubdate",
				startDate: begin || null,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
				// 'Access-Control-Allow-Origin': '*',
			},
		})
			.then((response) => response.json())
			.then((json) =>
				dispatch({
					type: RECEIVE_REPORTS,
					payload: {
						reports: json.articles,
						reportsHaveNeverLoaded: false,
						// articleHeaders: json.headers,
						reportsHeaders: buildTableHeaders({
							headerNames: json.headers,
							options: headerTypes,
							append: [],
						}),
						reportsLoading: false,
					},
				})
			)
			.catch((error, json) => {
				console.log(json);
				console.error(error);
			});
	};
};


// --- Crosstabs ---
export const fetchCrosstabsStats = (params) => {
	const { entityString, futureDateObject, futureEntityFilters, futureNarrativeFilters, futurePerspective, futureTopic } = params;
	return (dispatch, getState) => {
		const { api, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { aiOnly } = getState().commonUI;
		const {
			altProjectForCrosstabsNarratives,
			analystSystem,
			configureStats,
			desiredCrosstabsNarrativeOrder,
			crosstabsBargraphTopLeft,
			crosstabsBargraphMiddleTopLeft,
			crosstabsBargraphMiddleLeft,
			crosstabsBargraphMiddleBottomLeft,
			crosstabsBargraphBottomLeft,
			crosstabsBargraphTopRight,
			crosstabsBargraphMiddleRight,
			crosstabsBargraphBottomRight,
			crosstabsNarrativeFacets,
		} = getState().projectConfig;
		const { baselineDateBegin, baselineDateEnd, flatNarratives, relevancy } = getState().base;
		const staging = getState().base.stagingData;
		const { currentTopic, entity, entityFilters, narrativeFilters, perspective, selectedDateRange } = getState().crosstabs;
		const userPool = userData && userData.pool && userData.pool.userPoolId;

		// FLAG_ENABLE_MULTIPLE_NARRATIVE_FILTERS - TODO: Probably switch back if re-enabling narrative filters
		// -- switching to currentTopic from narrativeFilters[0] to fix a bug where setting the topic on CrosstabsInit returns All Topics
		const narrative = futureTopic || (futureNarrativeFilters ? futureNarrativeFilters[0] : currentTopic);
		// const narrative = futureTopic || (futureNarrativeFilters ? futureNarrativeFilters[0] : narrativeFilters[0]);

		const entityObj = entityString
			? {
					name: entityString,
					id: entityString,
					type: "Persons",
					parent: "keywords",
			  }
			: {
					name: entity.name,
					id: entity.id,
					type: entity.type,
					parent: "keywords",
			  };
		const entityFiltersForFetch = futureEntityFilters || entityFilters;
		const filters = formatFiltersForPost([...entityFiltersForFetch, entityObj]);
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(`${api.crosstabs}`, {
			method: "POST",
			mode: "cors",
			body: JSON.stringify({
				ai: aiOnly,
				analystSystem,
				endDate: baselineDateEnd ? baselineDateEnd.toString() : null,
				filters,
				parent: narrative.parent,
				perspective: futurePerspective || perspective,
				narrative: narrative.id,
				relevancy,
				startDate: setStartDate({ begin: baselineDateBegin, rangeObj: futureDateObject || selectedDateRange, end: baselineDateEnd }),
				project: altProjectForCrosstabsNarratives || api.key,
				user: `${userName}_${userPool}`,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
		.then((response) => {
			if (!response.ok) {
				throw new Error(SERVER_ERROR);
			}
			return response.text();
		})
		.then((data) => {
			return data ? JSON.parse(data) : {};
		})
		.then((json) => {
			return dispatch({
				type: RECEIVE_CROSSTABS_STATS,
				stats: json,
				flatNarratives,
				configureStats,
				entityFilters: entityFiltersForFetch,
				// FLAG_ENABLE_MULTIPLE_NARRATIVE_FILTERS - unhack this when the time comes
				narrativeFilters: [narrative],
				desiredCrosstabsNarrativeOrder,
				crosstabsBargraphTopLeft,
				crosstabsBargraphMiddleTopLeft,
				crosstabsBargraphMiddleLeft,
				crosstabsBargraphMiddleBottomLeft,
				crosstabsBargraphBottomLeft,
				crosstabsBargraphTopRight,
				crosstabsBargraphMiddleRight,
				crosstabsBargraphBottomRight,
				crosstabsNarrativeFacets,
			})
		})
		.catch((error, json) => {
			console.error(error, json);
		});
	};
};

export const fetchEntityMapStats = (params) => {
	const { entityString, futureDateObject, futureEntityFilters, futureNarrativeFilters, futurePerspective, futureTopic } = params;
	return (dispatch, getState) => {
		const { api, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { aiOnly } = getState().commonUI;
		const { altProjectForCrosstabsNarratives, analystSystem } = getState().projectConfig;
		const { baselineDateBegin, baselineDateEnd, relevancy } = getState().base;
		const staging = getState().base.stagingData;
		const { entity, entityFilters, narrativeFilters, perspective, selectedDateRange } = getState().crosstabs;
		const userPool = userData && userData.pool && userData.pool.userPoolId;

		// FLAG_ENABLE_MULTIPLE_NARRATIVE_FILTERS
		const narrative = futureTopic || (futureNarrativeFilters ? futureNarrativeFilters[0] : narrativeFilters[0]);

		const entityObj = entityString
			? {
					name: entityString,
					id: entityString,
					type: "Persons",
					parent: "keywords",
			  }
			: {
					name: entity.name,
					id: entity.id,
					type: entity.type,
					parent: "keywords",
			  };
		const entityFiltersForFetch = futureEntityFilters || entityFilters;
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(`${api.map}?staging=${staging}`, {
			method: "POST",
			mode: "cors",
			body: JSON.stringify({
				// aggregationType: stateCode ? dmaAggregation ? "dma" : "county" : "state", // state/county/dma
				aggregationType: "state", // state/county/dma
				ai: aiOnly,
				analystSystem,
				endDate: baselineDateEnd ? baselineDateEnd.toString() : null,
				event: false,
				filters: formatFiltersForPost([...entityFiltersForFetch, entityObj]),
				includeCounties: false,
				parent: narrative.parent,
				perspective: futurePerspective || perspective,
				max: 20,
				narrative: narrative.id === "narratives" ? "ALL" : narrative.id,
				relevancy,
				slice: 7,
				startDate: setStartDate({ begin: baselineDateBegin, rangeObj: futureDateObject || selectedDateRange, end: baselineDateEnd }),
				// state: stateCode, // required for aggregationType county
				project: altProjectForCrosstabsNarratives || api.key,
				user: `${userName}_${userPool}`,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => response.json())
			.then((json) =>
				dispatch({
					type: RECEIVE_CROSSTABS_MAP_STATS,
					data: json,
				})
			)
			.catch((error, json) => {
				console.error(error, json);
			});
	};
};


// --- Data Explorer Filters ---
export const fetchDataExplorerFilters = () => {
	return (dispatch, getState) => {
		const staging = getState().base.stagingData;
		const dataset = getState().dataExplorer.currentDatasetId
		const { api, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(`${api.narratives}?staging=${staging}`, {
			method: "POST",
			mode: "cors",
			body: JSON.stringify({
				MOE: true,
				project: `bfdab55f438bcad35974889ee35d83be_${dataset}`,
				userName,
				userPool,
				user: `${userName}_${userPool}`,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
				// 'Access-Control-Allow-Origin': '*',
			},
		})
			.then((response) => response.json())
			.then((json) => {
				let apiFilters = Array.isArray(json) ? json : Object.values(json);
				if (!Array.isArray(apiFilters)) {
					apiFilters = [];
				}
				decorateFilters(apiFilters);				
				dispatch({type: RECEIVE_DATA_EXPLORER_FILTERS, filters: apiFilters})
				// Get any child filters for dynamic filters which have an initial "open" status
				for (let i=0; i<apiFilters.length; i++) {
					if (apiFilters[i].type === DYNAMIC_FILTER_TYPE && apiFilters[i].status === "open") {
						dispatch(fetchMediaDynamicFilters(apiFilters[i]));
					}
				}
			})
			.catch((error) => {
				console.error("fetchDataExplorerFilters error", error);
			});
	};
};

// Data Explorer dynamic filters
const deDynamicFilterAbortControllers = {};
const abortDEDynamicFiltersFetch = (filterId) => {
	if (deDynamicFilterAbortControllers[filterId]) {
		deDynamicFilterAbortControllers[filterId].abort();
		delete deDynamicFilterAbortControllers[filterId];
	}
}

export const fetchDataExplorerDynamicFilters = (filter) => {
	if (!filter.fieldName || filter.status !== "open") {
		return () => {};
	}
	return (dispatch, getState) => {
		const { 
			activeSearchTranslationEnabled, 
			activeSearchTranslationLanguages, 
			activeSearchObj, 
			currentFiltersList,
			currentZoom, 
			filters, 
		} = getState().dataExplorer;
		const { api, userData, userName, authToken } = getState().login;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const formattedFilters = formatHierarchyFiltersForPost(filters);
		const queryAdds = formatQueryAddsForPost(currentFiltersList);
		const queryExcludes = formatQueryExcludesForPost(currentFiltersList);

		const query = activeSearchObj && activeSearchObj.query && activeSearchObj.query.length > 0
			? activeSearchObj.query
			: undefined;

		const fieldSearch = filter.filterFilterString && filter.filterFilterString.length > 0
			? filter.filterFilterString
			: undefined;

		if (filter.isLoading) {
			abortDEDynamicFiltersFetch(filter.id);
		}
		deDynamicFilterAbortControllers[filter.id] = new AbortController();

		dispatch({ type: FETCHING_DATA_EXPLORER_DYNAMIC_FILTERS, parentFilter: filter })

		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure());

		// Fetch the filters and process response
		return fetch(`${api.dynamicMediaFilters}`, {
			method: "POST",
			signal: deDynamicFilterAbortControllers[filter.id].signal,
			mode: "cors",
			body: JSON.stringify({
				project: api.key,
				userName,
				userPool,
				user: `${userName}_${userPool}`,
				dataExplorerTab: true,
				fieldName: filter.fieldName,
				fieldSearch,
				query,
				queryExpand: activeSearchTranslationEnabled, 
				queryExpandLang: activeSearchTranslationLanguages, 
				filters: formattedFilters,
				queryAdd: queryAdds,
				queryExclude: queryExcludes,
				size: MAX_DYNAMIC_FILTERS, 
				startDate: currentZoom.begin,
				endDate: currentZoom.end,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error(SERVER_ERROR);
				}
				return response.json()
			})
			.then((json) => {
				const results = json.data;
				for (let i=0; i<results.length; i++) {
					results[i].type = DYNAMIC_FILTER_RESULT_TYPE
					results[i].parent = filter.id
					results[i].parentId = filter.id
					results[i].parentDisplayName = filter.name
				}
				dispatch({ type: RECEIVE_DATA_EXPLORER_DYNAMIC_FILTERS, newChildren: results, parentFilter: filter });
				if(deDynamicFilterAbortControllers[filter.id]) {
					delete deDynamicFilterAbortControllers[filter.id];
				}
			})
			.catch((error) => {
				if (error.name === 'AbortError') {
					// No action needed
				}
				else {
					dispatch({ type: RECEIVE_DATA_EXPLORER_DYNAMIC_FILTERS_ERROR, filter});
				}
				if(deDynamicFilterAbortControllers[filter.id]) {
					delete deDynamicFilterAbortControllers[filter.id];
				}
			});
	};
};

// --- Data Explorer Entities ---
let deEntitiesAbortController;
const abortDEEntitiesFetch = () => {
	if (deEntitiesAbortController) {
		deEntitiesAbortController.abort();
	}
}

export const doFetchDataExplorerEntities = (params) => {
	const { endDate, startDate, fetchKey, filtersList, queryString } = params;
	return (dispatch, getState) => {
		const staging = getState().base.stagingData;
		const dataset = getState().dataExplorer.currentDatasetId;
		const { entitiesFetchingRetryCount } = getState().dataExplorer;
		const { api, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const userPool = userData && userData.pool && userData.pool.userPoolId;

		const filtersForAPI = formatFiltersForPost(filtersList);
		const queryAdds = formatQueryAddsForPost(filtersList);	
		
		deEntitiesAbortController = new AbortController();

		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(`${api.entities}?staging=${staging}`, {
			method: "POST",
			signal: deEntitiesAbortController.signal,
			mode: "cors",
			body: JSON.stringify({
				ai: false,
				analystSystem: false,
				endDate: endDate || Number(moment().add(7, "days").format("x")),
				event: false,
				filters: filtersForAPI,
				query: queryString || "*",
				queryAdds,
				perspective: "Source",
				project: `bfdab55f438bcad35974889ee35d83be_${dataset}`,
				max: 500,
				relevancy: 0.65,
				slice: 15,
				startDate: startDate || Number(moment().subtract(7, "days").format("x")),
				translateEntities: true,
				user: `${userName}_${userPool}`,
				dataExplorerTab: true,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
				// 'Access-Control-Allow-Origin': '*',
			},
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error(SERVER_ERROR);
				}
				return response.json()
			})
			.then((json) => {
				dispatch({ type: RECEIVE_DATA_EXPLORER_ENTITIES, entities: json, fetchKey });
			})
			.catch((error) => {
				if (error.name === 'AbortError') {
					// No action needed
					console.log('Entities fetch request aborted');
				}
				else if (entitiesFetchingRetryCount >= FETCH_RETRY_MAX) {
					console.error(error);
					dispatch({type: RECEIVE_DATA_EXPLORER_ENTITIES_ERROR});
				}
				else {
					console.warn(`${error} - Retry attempt ${entitiesFetchingRetryCount + 1}...`);
					dispatch({type: RECEIVE_DATA_EXPLORER_ENTITIES_RETRY});
					dispatch(doFetchDataExplorerEntities(params));
				}
			})
	};
};

export function fetchDataExplorerEntities(parameters) {
	return (dispatch, getState) => {
		const {	entitiesFetching} = getState().dataExplorer;
		if (entitiesFetching) {
			abortDEEntitiesFetch();
		}
		dispatch({ type: REQUEST_DATA_EXPLORER_ENTITIES });
		dispatch(doFetchDataExplorerEntities(parameters));
	};
};

export function updateDataExplorerEntities() {
	const fetchKey = `explorerRequest_${Date.now()}`;

	return (dispatch, getState) => {
		const { 
			activeSearchObj,
			currentFiltersList, 
			currentZoom,
			// filterMaps, 
			// filterTypeIds, 
			// entityFilters, 
			// endDate, 
			// startDate, 
		} = getState().dataExplorer;

		// let filtersList = [...entityFilters];
		// _.each(filterTypeIds, (filterId) => {
		// 	filtersList = [...filtersList, ...filterMaps[filterId].values()];
		// });

		dispatch(fetchDataExplorerEntities({ 
			queryString: activeSearchObj.query, 
			filtersList: currentFiltersList,
			endDate: currentZoom.end, 
			startDate: currentZoom.begin, 
			fetchKey,
		}));
	};
};

// -------------- Narrative Modal --------------
// Fetches a single timeseries for the graph tab
export function fetchNarrativeModalTimeseries(parameters) {
	const { narrative, selectedDateRange } = parameters;
	// aiOverride should only exist if loading a share view
	// console.log(
	// 	"fetchGraphTabTimeseries",
	// 	narrative,
	// 	narrative.id,
	// 	narrative.index,
	// 	// perspective,
	// 	// startDate,
	// 	// endDate,
	// 	filtersList,
	// );

	return (dispatch, getState) => {
		const staging = getState().base.stagingData;
		const { api, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { aiOnly } = getState().commonUI;
		const { baselineDateBegin, baselineDateEnd, relevancy } = getState().base;
		const { entity, entityFilters } = getState().crosstabs;
		const { analystSystem } = getState().projectConfig;
		const userPool = userData && userData.pool && userData.pool.userPoolId;

		const entityObj = {
			name: entity.name,
			id: entity.id,
			type: entity.type,
			parent: "keywords",
		};

		const startDate = setStartDate({ begin: baselineDateBegin, rangeObj: selectedDateRange, end: baselineDateEnd });
		const endDate = baselineDateEnd ? baselineDateEnd.toString() : null;

		const params = JSON.stringify({
			// aggregate: 7,
			ai: aiOnly,
			analystSystem,
			chartType: "articleCount",
			endDate,
			event: false,
			narrative: narrative.id,
			parent: narrative && narrative.parent,
			perspective: "Source",
			project: api.key,
			filters: formatFiltersForPost([...entityFilters, entityObj]),
			startDate,
			relevancy,
			user: `${userName}_${userPool}`,
		});
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(`${api.timeseries}?staging=${staging}`, {
			method: "POST",
			mode: "cors",
			body: params,
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
				// 'Access-Control-Allow-Origin': '*',
			},
		})
			.then((response) => response.json())
			.then((json) =>
				dispatch({
					type: RECEIVE_NARRATIVE_MODAL_TIMESERIES,
					data: json,
					// Because API currently ignores startDate and endDate
					endDate,
					startDate,
				})
			)
			.catch((error) => {
				console.error(error);
			});
	};
};

export const fetchNarrativeModalBargraph = (params) => {
	const { selectedDateRange } = params;
	return (dispatch, getState) => {
		const { api, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { aiOnly } = getState().commonUI;
		const {
			altProjectForCrosstabsNarratives,
			analystSystem,
			crosstabsNarrativeHeaderLabels,
			crosstabsNarrativeHeaders,
			desiredCrosstabsNarrativeOrder,
		} = getState().projectConfig;
		const { baselineDateBegin, baselineDateEnd, relevancy } = getState().base;
		// const staging = getState().base.stagingData;
		const { currentNarrativeFacet, currentTopic, entity, entityFilters, narrativeModalData, perspective } = getState().crosstabs;
		const userPool = userData && userData.pool && userData.pool.userPoolId;

		const entityObj = {
			name: entity.name,
			id: entity.id,
			type: entity.type,
			parent: "keywords",
		};
		const filters = formatFiltersForPost([...entityFilters, entityObj]);
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(`${api.crosstabs}`, {
			method: "POST",
			mode: "cors",
			body: JSON.stringify({
				ai: aiOnly,
				analystSystem,
				endDate: baselineDateEnd ? baselineDateEnd.toString() : null,
				event: false,
				filters,
				parent: currentTopic.parent,
				perspective,
				max: 20,
				narrative: currentTopic.id,
				relevancy,
				slice: 15,
				startDate: setStartDate({ begin: baselineDateBegin, rangeObj: selectedDateRange, end: baselineDateEnd }),
				project: altProjectForCrosstabsNarratives || api.key,
				user: `${userName}_${userPool}`,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => response.json())
			.then((json) =>
				dispatch({
					type: RECEIVE_NARRATIVE_MODAL_BARGRAPH,
					barGraph: formatNarrativeBarGraph({
						crosstabsNarrativeHeaders,
						currentNarrativeFacet,
						desiredOrder: desiredCrosstabsNarrativeOrder,
						labels: crosstabsNarrativeHeaderLabels,
						narrativeData: json && json.narratives && json.narratives[narrativeModalData.id],
					}),
				})
			)
			.catch((error, json) => {
				console.error(error, json);
			});
	};
};

// ----------------------------------------------------------------------

// TODO: unmock this with below
export const fetchReportsList = () => {
	return (dispatch, getState) => {
		_.each(mockReports, (report) => {
			report.hrefUrlTarget = "_blank";
		});
		dispatch({ type: "receiveReportList", reportsList: mockReports });
	};
};
// export const fetchReportsList = () => {
// 	console.log('fetchReportsList');
// 	return (dispatch, getState) => {
// 		const { api, userName, authToken } = getState().login;
// 		return fetch(api.reports,
// 			{
// 				method: "GET",
// 				mode: "cors",
// 				// headers: {
// 				// 	"Content-Type": "application/json",
// 				// 	// 'Access-Control-Allow-Origin': '*',
// 				// },
// 			}
// 		)
// 			.then((response) => response.text())
// 			.then((xml) => {
// 				// Convert the xml from the API to json - TODO: This is terrible & doesn't include a URL - wait on the API
// 				let json = {};
// 				parseString(xml, (err, result) => {
// 					json = result;
// 				});
// 				dispatch({
// 					type: "receiveReportList",
// 					reportsList: json && json.ListBucketResult && json.ListBucketResult.Contents,
// 				})
// 			})
// 			// .then((json) => dispatch({ type: "receiveReportList", reportsList: mockReports }))
// 			.catch((error) => {
// 				console.error("Request Reports Error", error);
// 			});
// 		// dispatch({ type: "receiveReportList", reportsList: mockReports })
// 	}
// }

export const downloadReport = (params) => {
	console.log("downloadReport", params);
	const { name } = params;
	return (dispatch, getState) => {
		const { api, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		dispatch({ type: "receiveReportList", reportsList: mockReports });
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return (
			fetch(`${api.reports}/${name}`, {
				method: "GET",
				mode: "cors",
				headers: {
					"Content-Type": "application/octet-stream",
					"Authorization": idToken
					// "Content-Type": "application/json",
					// 'Access-Control-Allow-Origin': '*',
				},
				responseType: "blob",
			})
				.then((response) => response.blob())
				// .then((response) => response.arrayBuffer())
				.then((file) => {
					console.log(file);
					download(file, name);
					// download(new Blob([file], {type: 'application/octet-stream'}), name);

					// const url = window.URL.createObjectURL(file);
					// const a = document.createElement('a');
					// a.href = url;
					// a.download = name;
					// a.click();

					// download(file, name);

					// breaks file & requires DOM element
					// const url = window.URL.createObjectURL(file);

					// const button = document.getElementById('download_link');
					// button.href = url;
					// button.download = name;
					// button.click();

					// window.URL.revokeObjectURL(url);
				})
				// .then((json) => dispatch({ type: "receiveReportList", reportsList: mockReports }))
				.catch((error) => {
					console.error("Request Reports Error", error);
				})
		);
	};
};

// // TODO: Unmock with below
// // Fetch Correlation
// export function fetchCorrelation(parameters) {
// 	return (dispatch, getState) => {
// 		const { fetchKey, data, id } = parameters;
// 		const { expectedEvents, timeseriesStorage } = getState().events;
// 		// console.log("fetchCorrelation", data, timeseriesStorage);
// 		// console.log("----------->", id);
// 		// Store time series data in events reducer (refactor if we do correlation outside of events)
// 		dispatch({
// 			type: "storeEventTimeseries",
// 			data,
// 			id,
// 		});

// 		// Count the timeseries as they return. Rejects any duplicates (just in case)
// 		const currentEvents = _.reject(expectedEvents, (eventId) => {
// 			return eventId === id;
// 		});
// 		dispatch({
// 			type: "eventCountdown",
// 			currentEvents,
// 		});

// 		console.log(currentEvents);
// 		// Once we have them all, request the correlation
// 		if (currentEvents.length <= 0) {
// 			console.log("All event time series have returned", parameters, timeseriesStorage);
// 			let primary = {};
// 			let secondary = [];
// 			if (timeseriesStorage.primary.id === id) {
// 				console.log("BLOCK ONE");

// 				primary = {
// 					timeseries: data.timeseries,
// 					id,
// 				};
// 				secondary = timeseriesStorage.secondary;
// 			} else {
// 				console.log("BLOCK TWO");
// 				primary = timeseriesStorage.primary;
// 				secondary = timeseriesStorage.secondary;
// 				const secondaryIndex = _.findIndex(timeseriesStorage.secondary, (second) => {
// 					return second.id === id;
// 				});
// 				secondary[secondaryIndex] = {
// 					id,
// 					timeseries: data.timeseries,
// 				};
// 			}
// 			const params = {
// 				correlationRange: 7,
// 				lag: "max",
// 				primary,
// 				secondary,
// 			};
// 			console.log("fetchCorrelation - PARAMS", params);

// 			dispatch(
// 				receiveCorrelation({
// 					correlation: mockCorrelation,
// 					fetchKey,
// 				})
// 			);
// 		}
// 	};
// }
const noZeros = (timeseries) => {
	const onlyZeros = true;
	const keys = Object.keys(timeseries);
	for (let i = 0; i < keys.length; i++) {
		timeseries[keys[i]] = Math.floor(Math.random() * 10);
	}

	// for (let i = 0; i < keys.length; i++) {
	// 	if (timeseries[keys[i]] > 0) {
	// 		onlyZeros = false;
	// 		break;
	// 	}
	// }
	// if (onlyZeros) {
	// 	timeseries[keys[0]] = 1;
	// }

	return timeseries;
};

export function fetchCorrelation(parameters) {
	return (dispatch, getState) => {
		const { fetchKey, data, id } = parameters;
		const { expectedEvents, timeseriesStorage } = getState().events;
		const { api, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const staging = getState().base.stagingData;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		// console.log("fetchCorrelation", data, id, expectedEvents);
		// Store time series data in events reducer (refactor if we do correlation outside of events)
		dispatch({
			type: "storeEventTimeseries",
			data,
			id,
		});

		// Count the timeseries as they return.
		const currentEvents = _.reject(expectedEvents, (eventId) => {
			return eventId === id;
		});
		dispatch({
			type: "eventCountdown",
			currentEvents,
		});

		// Once we have them all, request the correlation
		if (currentEvents.length <= 0) {
			// console.log("All event time series have returned", parameters, timeseriesStorage);
			let primary = {};
			let secondary = [];
			if (timeseriesStorage.primary.id === id) {
				primary = {
					data: data.timeseries,
					id,
					name: id,
				};
				secondary = timeseriesStorage.secondary;
			} else {
				primary = timeseriesStorage.primary;
				secondary = timeseriesStorage.secondary;
				const secondaryIndex = _.findIndex(timeseriesStorage.secondary, (second) => {
					return second.id === id;
				});
				secondary[secondaryIndex] = {
					id,
					name: id,
					data: data.timeseries,
				};
			}

			// Only request a correlation if there is a primary time series
			if (primary.data) {
				// Trim all timeseries to match
				const secondaryTimeseries = _.pluck(secondary, "data");
				const smallestCommonRange = findCommonRange([primary.data, ...secondaryTimeseries]);

				primary.data = trimSeries({
					timeseries: primary.data,
					zoom: smallestCommonRange,
				});
				_.each(secondary, (second) => {
					second.data = trimSeries({
						timeseries: second.data,
						zoom: smallestCommonRange,
					});
				});

				const params = {
					correlationRange: 7,
					lag: "max",
					primary,
					secondary,
					project: api.key,
					user: `${userName}_${userPool}`,
				};
				// forcibly refresh tokens
				Auth.currentSession().catch(() => dispatchTokenFailure())
				// console.log("All event time series have returned - PARAMS", params);
				return fetch(`${api.correlation}?staging=${staging}`, {
					// return fetch(`${api.correlation}?staging=${staging}`, {
					method: "POST",
					mode: "cors",
					body: JSON.stringify(params),
					headers: {
						"Content-Type": "application/json",
						"Authorization": idToken
					},
				})
					.then((response) => response.json())
					.then((json) =>
						dispatch(
							receiveCorrelation({
								correlation: json,
								fetchKey,
							})
						)
					)
					.catch((error) => {
						console.error(error);
					});
			}
		}
	};
};

// Directly downloads the API response
export function exportContent(parameters) {
	const {
		adjustForAggregation = false,
		ascending, 
		contentFilteredByDate, 
		endDate, 
		filters, 
		narrative, 
		perspective, 
		sortBy, 
		startDate
	} = parameters;
	
	return (dispatch, getState) => {
		const { relevancy, stagingData } = getState().base;
		const { aggregationLevel } = getState().base;
		const { api, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { aiOnly } = getState().commonUI;
		const { analystSystem } = getState().projectConfig;
		const narrativeId = narrative.parent === "self" ? undefined : narrative.id;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		dispatch({ type: "disableExportButton" });

		const filteredStartDate = contentFilteredByDate ? Number(contentFilteredByDate.begin) : startDate;
		const adjustedStartDate = adjustForAggregation 
			? adjustStartDateForAggregation({filteredStartDate, aggregationLevel}).toString() 
			: filteredStartDate;	
		const adjustedEndDate = contentFilteredByDate 
			? Number(contentFilteredByDate.end) 
			: endDate;

		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(`${api.articles}?staging=${stagingData}`, {
			method: "POST",
			mode: "cors",
			body: JSON.stringify({
				analystSystem,
				startDate: adjustedStartDate,
				endDate: adjustedEndDate,
				event: isThisAnEvent({ id: narrative.id, events: getState().events.eventTypes }),
				// slice: 15,
				narrative: narrativeId,
				perspective,
				outputType: "export",
				outputFormat: "csv",
				project: api.key,
				filters: formatFiltersForPost(filters),
				parent: narrative.parent,
				sort: [sortBy],
				asc: ascending,
				desc: !ascending,
				ai: aiOnly,
				relevancy,
				user: `${userName}_${userPool}`,
			}),
			headers: {
				// "Content-Type": "application/json",
				"Content-Type": "application/csv",
				"Authorization": idToken
			},
			responseType: "blob",
		})
			.then((response) => response.blob())
			.then((csv) => {
				const formattedFileName = narrative.name || new Date().toISOString();
				download(csv, `${formattedFileName}.csv`, "application/csv");
				dispatch({ type: "enableExportButton" });
			})
			.catch((error) => {
				console.error(error);
				dispatch({ type: "showExportError" });
				dispatch({ type: "enableExportButton" });
				setTimeout(() => {
					dispatch({ type: "clearExportError" });
				}, 8000);
			});
	};
};

// Directly downloads the API response
export function exportContentCompare(parameters) {
	const { 
		adjustForAggregation = false,
		ascending, 
		contentFilteredByDate, 
		endDate, 
		filters, 
		narrative, 
		perspective, 
		side, 
		sortBy, 
		startDate
	} = parameters;
	
	return (dispatch, getState) => {
		const staging = getState().base.stagingData;
		const { api, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { aiOnly } = getState().commonUI;
		const { aggregationLevel } = side === "Left" ? getState().leftCompare : getState().rightCompare;
		const { analystSystem } = getState().projectConfig;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		dispatch({ type: `disableExportButton${side}` });
		const narrativeId = narrative.parent === "self" ? undefined : narrative.id;
		
		const filteredStartDate = contentFilteredByDate ? Number(contentFilteredByDate.begin) : startDate;
		const adjustedStartDate = adjustForAggregation 
			? adjustStartDateForAggregation({filteredStartDate, aggregationLevel}).toString() 
			: filteredStartDate;	
			const adjustedEndDate = contentFilteredByDate 
				? Number(contentFilteredByDate.end) 
				: endDate;

		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(`${api.articles}?staging=${staging}`, {
			method: "POST",
			mode: "cors",
			body: JSON.stringify({
				analystSystem,
				startDate: adjustedStartDate,
				endDate: adjustedEndDate,
				event: isThisAnEvent({ id: narrativeId, events: getState().events.eventTypes }),
				// slice: 15,
				narrative: narrativeId,
				perspective,
				outputType: "export",
				outputFormat: "csv",
				project: api.key,
				filters: formatFiltersForPost(filters),
				parent: narrative.parent,
				sort: [sortBy],
				asc: ascending,
				desc: !ascending,
				ai: aiOnly,
				user: `${userName}_${userPool}`,
			}),
			headers: {
				// "Content-Type": "application/json",
				"Content-Type": "application/csv",
				"Authorization": idToken
			},
			responseType: "blob",
		})
			.then((response) => response.blob())
			.then((csv) => {
				const formattedFileName = narrative.name || new Date().toISOString();
				download(csv, `${formattedFileName}.csv`, "application/csv");
				dispatch({ type: `enableExportButton${side}` });
			})
			.catch((error) => {
				console.error(error);
				dispatch({ type: `showExportError${side}` });
				dispatch({ type: `enableExportButton${side}` });
				setTimeout(() => {
					dispatch({ type: `clearExportError${side}` });
				}, 8000);
			});
	};
};

export function checkNotifications(clearedNotifications) {
	return (dispatch, getState) => {
		const staging = getState().base.stagingData;
		const { api, userData, userName, authToken } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		if (api.notifications) {
			return fetch(`${api.notifications}?staging=${staging}`, {
				method: "POST",
				mode: "cors",
				body: JSON.stringify({
					project: api.key,
					user: `${userName}_${userPool}`,
				}),
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			})
				.then((response) => response.json())
				.then((json) =>
					dispatch({
						type: "receiveNotificaitons",
						data: json,
						clearedNotifications,
					})
				)
				.catch((error) => {
					console.error(error);
				});
		}
	};
};

export function translateArticle(params) {
	const { sourceLang, targetLang, text, textType } = params;
	// console.log("translateArticle", text);
	return (dispatch) => {
		return fetch(
			`https://translate.googleapis.com/translate_a/single?client=gtx&sl=${sourceLang}&tl=${targetLang}&dt=t&q=${encodeURI(text)}`,
			{
				method: "GET",
			}
		)
			.then((response) => response.json())
			.then((json) =>
				dispatch({
					type: "receiveTranslation",
					data: json,
					textType,
				})
			)
			.catch((error) => {
				dispatch({
					type: "translationError",
					error,
				});
			});
	};
};

// FLAG_ATTEMPTING_TO_TRANSLATE_MISSING_TRANSCRIPTS
export function translateTranscript({ data, index, callsRequired }) {
	const { lang, transcriptHtml } = data;
	const sourceLang = langCodeLookup(lang);
	const targetLang = "en";

	// const textArray = [];
	// const startIndex = index * 50;
	// const segmentSlice = transcriptJson.segments.slice(startIndex, startIndex + 50);
	// const textString = JSON.stringify(segmentSlice);
	// const textString = JSON.stringify(transcriptJson.segments);

	// _.each(segmentSlice, (textObj) => {
	// 	textArray.push(textObj.text);
	// });

	console.log("translateTranscript", textString);
	return (dispatch) => {
		return fetch(
			`https://translate.googleapis.com/translate_a/single?client=gtx&sl=${sourceLang}&tl=${targetLang}&dt=t&q=${transcriptHtml}`,
			{
				method: "GET",
			}
		)
			.then((response) => response.json())
			.then((json) =>
				dispatch({
					type: ADD_TRANSLATION_TO_TRANSCRIPTS,
					data: json,
					// segments: segmentSlice,
					// startIndex,
					// callsRequired,
				})
			)
			.catch((error) => console.error(error));
	};
};


// ------------- Email subscription ------------
export function getUserSubscriptions() {
	return (dispatch, getState) => {
		const { api, userEmail, userName, authToken } = getState().login;
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		return fetch(`${api.emailSubscribe}?email=${userEmail}`, {
			method: "GET",
			mode: "cors",
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => response.json())
			.then((json) => {
				dispatch({
					type: RECEIVE_USER_SUBSCRIPTIONS,
					subscriptions: json || [],
				});
			})
			.catch((error) => {
				// dispatch({
				// 	type: "getUserSubscriptionsError",
				// 	error,
				// })
				console.error("Error in getUserSubscriptions fetch", error);
			});
	};
};

export function subscribeToEmail() {
	return (dispatch, getState) => {
		const { api, userEmail, emailSubscriptions, userName, authToken } = getState().login;
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { emailSubscribeOption } = getState().projectConfig;
		console.log("subscribeToEmail", addOrRemoveString(emailSubscriptions, emailSubscribeOption));

		// // MOCKED:
		// dispatch({
		// 	type: "subscribeToEmailSuccess",
		// 	subscriptions: addOrRemoveString(emailSubscriptions, currentProject),
		// })

		// UNMOCK: - (this is the unmocked version)
		return fetch(api.emailSubscribe, {
			method: "POST",
			body: JSON.stringify({
				email: userEmail,
				lists: addOrRemoveString(emailSubscriptions, emailSubscribeOption),
			}),
			mode: "cors",
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => response.json())
			.then((json) =>
				// NOTE: May want to do this manually
				dispatch({
					type: "subscribeToEmailSuccess",
					response: json,
				})
			)
			.catch((error) => {
				dispatch({
					type: "subscribeToEmailError",
					error,
				});
				console.error("Error in subscribeToEmail fetch", error);
			});
	};
};


// -------- Share feature -------
export function saveShare(params) {
	return (dispatch, getState) => {
		const { contentSingleArticleId, position } = params;
		const { api, currentProject, userData, userName, authToken } = getState().login;

		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		const { location } = getState().router;
		const {
			activeNarrativeData,
			activeRelevancy,
			contentFilteredByDate,
			contentHeaderSortTypeSource,
			contentHeaderSortTypeAudience,
			contentHeaderSortAscendingSource,
			contentHeaderSortAscendingAudience,
			currentZoom,
			perspective,
			filtersList,
			entityFilters,
			activeKeywords,
			mapHighlightId,
			stagingData,
		} = getState().base;
		const { aiOnly } = getState().commonUI;
		const { lines } = getState().graphTab;
		const { expandedContentId, expandedContentIndex } = getState().expandedContent;
		console.log(expandedContentId);
		const { activeContentTabFilters, currentContentTab, dateStart, dateEnd } = getState().contentTab;
		const userPool = userData && userData.pool && userData.pool.userPoolId;

		const graphMode = location && location.pathname === "/graph";
		const curatedMode = location && location.pathname === "/curated";
		const narrativesMode = location && location.pathname === "/narratives";
		const mediaMode = location && location.pathname === "/media";
		const tabSlug = location && location.pathname ? location.pathname.replace(/^\//, "") : "";
		// Set the sort variables by perspective
		const contentHeaderSortType = perspective === "Source" ? contentHeaderSortTypeSource : contentHeaderSortTypeAudience;
		const contentHeaderSortAscending = perspective === "Source" ? contentHeaderSortAscendingSource : contentHeaderSortAscendingAudience;

		// Declare view specific variables
		let narrativeTab = {};
		let contentTab = {};
		let mediaTab = {};
		const graphTabLineIdArr = [];

		// Assign data based on the current view
		if (graphMode) {
			_.each(lines, (line) => {
				graphTabLineIdArr.push({
					id: line.id,
					filtersList: line.filters,
					perspective: line.perspective,
					parent: line.parent,
					info: line.info,
					name: line.name,
					optimalLag: line.optimalLag,
					predictiveVal: line.predictiveVal,
					type: line.type,
				});
			});
		} else if (curatedMode) {
			contentTab = {
				filters: activeContentTabFilters,
				dateStart,
				dateEnd,
				currentTab: currentContentTab,
				contentSingleArticleId,
			};
		} else if (narrativesMode) {
			narrativeTab = {
				activeNarrativeData: cloneObjectWithout({
					obj: activeNarrativeData,
					withoutArr: ["timeseries", "weeklyTimeseries", "monthlyTimeseries", "query", "info"],
				}),
				activeRelevancy,
				contentFilteredByDate,
				contentHeaderSortAscending,
				contentHeaderSortType,
				currentZoom,
				expandedContentId,
				expandedContentIndex,
				perspective,
				activeFilters: filtersList,
				entityFilters,
				activeKeywords,
				mapHighlightId,
			};
		} else if (mediaMode) {
			mediaTab = {
				expandedContentId,
				expandedContentIndex,
			};
		}

		// // hack smash mock
		// _.each(narrativeTab.activeNarrativeData.children, (child) => {
		// 	child.header = null;
		// });

		// Including children sometimes causes dynamo error, and they aren't necessary
		if (narrativeTab.activeNarrativeData && narrativeTab.activeNarrativeData.children) {
			narrativeTab.activeNarrativeData.children = [];
		}

		const shareDataObj = {
			aiOnly,
			contentTab,
			graphTabLineIdArr,
			mediaTab,
			navMode: tabSlug,
			narrativeTab,
			projectId: currentProject,
			stagingData,
		};
		const shareData = JSON.stringify(shareDataObj);

		// const routeId = md5(JSON.stringify(shareData));
		// console.log("contentTab", contentTab);
		// console.log("saveShare", shareData);
		// console.log("routeId", routeId);
		// // dispatch({ type: "displayShareLink", routeId, position });
		// console.log('userName', userName);
		// console.log('userPool,', userPool);
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(`${api.save}`, {
			method: "POST",
			body: JSON.stringify({
				// routeId,
				userName,
				userPool,
				shareData,
			}),
			mode: "cors",
			headers: {
				"Content-Type": "application/json",
				"Authorization": idToken,
			},
		})
			.then((response) => response.json())
			.then((json) => {
				if (_.isEmpty(json.body)) {
					dispatch({
						type: "displayShareLink",
						response: json,
						position,
					});
				} else {
					dispatch({
						type: "displayShareLinkError",
						response: json,
						position,
					});
				}
			})
			.catch((error) => {
				console.error("saveShare error =>", error);
			});
	};
};

// // MOCK version:
// export function loadShareData(params) {
// 	const { shareId } = params;
// 	return (dispatch, getState) => {
// 		const json = mockShareData;

// 		const { api, availableProjects, currentProject } = getState().login;

// 		if (json) {
// 			const { aiOverride, contentTab, navMode, narrativeTab, projectId } = json;

// 			const baseURL = window.location.href.split("?")[0];
// 			const currentProjectCorrect = currentProject === projectId;
// 			const userHasAccessToThisProject = _.find(availableProjects, (project) => {
// 				return project.id === projectId;
// 			});

// 			// Make sure the user has access
// 			if (userHasAccessToThisProject) {
// 				// Set correct project here - NOTE: this will cause a refresh
// 				if (!currentProjectCorrect) {
// 					dispatch({ type: SET_PROJECT, project: userHasAccessToThisProject.id });
// 					dispatch({ type: RESET_DATA });
// 				}

// 				// Clean up URL - NOTE: this must happen after the project changes.
// 				setTimeout(() => {
// 					window.history.pushState({}, document.title, baseURL);
// 				}, 2000);

// 				// seed data that doesn't need a secondary fetch
// 				dispatch({
// 					type: "loadShareData",
// 					data: json,
// 				});

// 				// fetch data depending on the tab
// 				if (navMode === "graph") {
// 					// Graph tab data fetch
// 					if (api.listTimeseries) {
// 						fetchTimeseriesList({ aiOverride });
// 						fetchGraphTabFilterOptions({ aiOverride }); // get available filter types
// 					}
// 					_.each(json.graphTabLineIdArr, (line) => {
// 						dispatch(
// 							fetchGraphTabTimeseries({
// 								narrative: line,
// 								perspective: line.perspective,
// 								filtersList: line.filtersList,
// 								aiOverride,
// 							})
// 						);
// 					});
// 					// Should grab trends if available, even if loading graph tab first
// 					if (api.narratives) {
// 						dispatch(fetchTrends());
// 					}
// 				} else if (navMode === "curated") {
// 					// Content tab data fetch
// 					if (api.content && api.contentFilters) {
// 						dispatch(fetchContentFilters({ aiOverride }));
// 						dispatch(
// 							fetchContentArticles({
// 								filters: contentTab.filters,
// 								dateStart: contentTab.dateStart,
// 								dateEnd: contentTab.dateEnd,
// 								aiOverride,
// 								share: true,
// 								shareSingleArticleId: contentTab.contentSingleArticleId,
// 							})
// 						);
// 						// Should grab trends if available, even if loading content tab first
// 						if (api.narratives) {
// 							dispatch(fetchTrends());
// 						}
// 					}
// 					if (contentTab.currentTab) {
// 						dispatch({ type: "setDefaultTab", defaultTab: contentTab.currentTab });
// 					}
// 				} else if (navMode === "narratives") {
// 					const {
// 						activeFilters,
// 						activeKeywords,
// 						activeNarrativeData,
// 						contentFilteredByDate,
// 						contentHeaderSortAscending,
// 						contentHeaderSortType,
// 						currentZoom,
// 						entityFilters,
// 						mapHighlightId,
// 						perspective,
// 					} = narrativeTab;
// 					// Set content sort, before the data is fetched
// 					if (contentHeaderSortType) { // Should always be true for new shares
// 						dispatch({
// 							type: "setContentSort",
// 							sortBy: contentHeaderSortType,
// 							ascending: contentHeaderSortAscending,
// 							perspective,
// 						});
// 					}
// 					dispatch(fetchTrends({
// 						activeFilters,
// 						contentFilteredByDate,
// 						entityFilters,
// 						currentZoom,
// 						keywords: activeKeywords,
// 						mapHighlightId,
// 						activeNarrativeData,
// 						perspective,
// 					}));
// 					dispatch({ type: "setActiveNarrativeFromShare", activeNarrativeData })
// 					// Set zoom, even if it was on History
// 					dispatch({ type: SET_CURRENT_ZOOM, currentZoom });
// 					// Sets the indicator - has to happen after SET_CURRENT_ZOOM
// 					dispatch({ type: FILTER_CONTENT_BY_DATE, ontentFilteredByDate });
// 					// The keywords need to appear in the UI
// 					dispatch({ type: "setVisibleKeywordsFromSaved", newKeywords: activeKeywords });
// 					// Open entity filters drawer if we have entity filters
// 					if (entityFilters && entityFilters.length > 0) {
// 						dispatch({ type: "openSidebarEntities" });
// 					}
// 				}
// 			} else {
// 				dispatch({ type: "noShareAccessError", url: `${baseURL}?share=${shareId}` });
// 			}
// 		} else {
// 			console.error("No json to load in loadShareData", json);
// 		}
// 	};
// }

export function loadShareData(params) {
	const { shareId } = params;
	return (dispatch, getState) => {
		const { api, availableProjects, currentProject, authToken, userName } = getState().login;
		const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		// console.log('availableProjects', availableProjects);
		// forcibly refresh tokens
		Auth.currentSession().catch(() => dispatchTokenFailure())
		return fetch(`${api.save}/${shareId}`, {
			method: "GET",
			mode: "cors",
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => response.json())
			.then((json) => {
				if (json) {
					const shareData = JSON.parse(json.shareData);
					const { aiOverride, contentTab, mediaTab, narrativeTab, navMode, projectId } = shareData;
					const baseURL = window.location.href.split("?")[0];
					const currentProjectCorrect = currentProject === projectId;
					const userHasAccessToThisProject = _.find(availableProjects, (project) => {
						return project.id === projectId;
					});

					// // Make sure the user has access
					if (userHasAccessToThisProject) {
						// Set correct project here - NOTE: this will cause a refresh
						if (!currentProjectCorrect) {
							dispatch({ type: SET_PROJECT, project: userHasAccessToThisProject.id });
							dispatch({ type: RESET_DATA });
						} 

						// Clean up URL - NOTE: this must happen after the project changes.
						setTimeout(() => {
							window.history.pushState({}, document.title, baseURL);
						}, 2000);

						// seed data that doesn't need a secondary fetch
						dispatch({
							type: "loadShareData",
							data: json,
						});

						// Graph tab data fetch
						if (api.listTimeseries) {
							dispatch(fetchTimeseriesList({ aiOverride }));
							dispatch(fetchGraphTabFilterOptions({ aiOverride })); // get available filter types
						}

						// fetch data depending on the tab
						if (navMode === "graph") {
							dispatch({ type: "graphNavigation" });
							_.each(json.graphTabLineIdArr, (line) => {
								dispatch({ type: "graphNavigation" });
								dispatch(
									fetchGraphTabTimeseries({
										narrative: line,
										perspective: line.perspective,
										filtersList: line.filtersList,
										aiOverride,
									})
								);
							});
							if (api.narratives) {
								dispatch(fetchTrends()); // load base narratives
							}
						} else if (navMode === "media") {
							const {	expandedContentId, expandedContentIndex } = mediaTab;
							if (expandedContentId) {
								dispatch(fetchArticleData({ id: expandedContentId, nav: navMode, index: expandedContentIndex }));
								dispatch({ type: "openContentModal" });
							}
						} else if (navMode === "curated") {
							// console.log('LOAD content tab ----->', contentTab);
							dispatch({ type: CONTENT_NAVIGATION });
							// Content tab data fetch
							if (api.content && api.contentFilters) {
								dispatch(fetchContentFilters({ aiOverride }));
								dispatch(
									fetchContentArticles({
										filters: contentTab.filters,
										dateStart: contentTab.dateStart,
										dateEnd: contentTab.dateEnd,
										aiOverride,
										share: true,
										shareSingleArticleId: contentTab.contentSingleArticleId,
									})
								);
							}
							if (api.narratives) {
								dispatch(fetchTrends()); // load base narratives
							}
							if (contentTab.currentTab) {
								dispatch({ type: "setDefaultTab", defaultTab: contentTab.currentTab });
							}
						} else if (navMode === "narratives") {
							dispatch({ type: "narrativeNavigation" });
							const {
								activeFilters,
								activeKeywords,
								activeNarrativeData,
								activeRelevancy,
								contentHeaderSortAscending,
								contentHeaderSortType,
								contentFilteredByDate,
								currentZoom,
								entityFilters,
								expandedContentId,
								expandedContentIndex,
								mapHighlightId,
								perspective,
							} = narrativeTab;
							// Set content sort, before the data is fetched
							if (contentHeaderSortType) {
								// Should always be true for new shares
								dispatch({
									type: "setContentSort",
									sortBy: contentHeaderSortType,
									ascending: contentHeaderSortAscending,
									perspective,
								});
							}
							// Set them all to a custom date range
							currentZoom.name = "Custom";
							console.log("LOAD ----- narrativeTab ----->", narrativeTab);
							// dispatch({
							// 	type: SYNC_RELEVANCY,
							// 	payload: { relevancy: activeRelevancy, activeRelevancy },
							// });
							// REVISIT JA: graph and article list are not loading correctly fetchTrends needs to be replaced 
							// here with something more specific (i.e. that will not reset all state) to resolve this
							// dispatch(
							// 	fetchTrends({
							// 		activeFilters,
							// 		activeNarrativeData,
							// 		contentFilteredByDate,
							// 		currentZoom,
							// 		entityFilters,
							// 		keywords: activeKeywords,
							// 		mapHighlightId,
							// 		perspective,
							// 		relevancyOverride: activeRelevancy,
							// 	})
							// );
							dispatch({ type: "setActiveNarrativeFromShare", activeNarrativeData });
							// Set zoom, even if it was on History
							dispatch({ type: SET_CURRENT_ZOOM, currentZoom });
							// Sets the indicator - has to go after SET_CURRENT_ZOOM
							dispatch({ type: FILTER_CONTENT_BY_DATE, contentFilteredByDate });
							// The keywords need to appear in the UI
							dispatch({ type: "setVisibleKeywordsFromSaved", newKeywords: activeKeywords });
							// Open entity filters drawer if we have entity filters
							if (entityFilters && entityFilters.length > 0) {
								dispatch({ type: "openSidebarEntities" });
							}
							if (expandedContentId) {
								dispatch(fetchArticleData({ id: expandedContentId, index: expandedContentIndex }));
								dispatch({ type: "openContentModal" });
							}
						}
					} else {
						dispatch({ type: "noShareAccessError", url: `${baseURL}?share=${shareId}` });
					}
				} else {
					console.error("No json to load in loadShareData", json);
				}
			})
			.catch((error) => {
				console.error("saveShare error =>", error);
				const baseURL = window.location.href.split("?")[0];
				const varURL = window.location.href.split("?share=")[1];
				window.location.replace(`${baseURL}?sharefail=${varURL}`);
			});
	};
};

// ----- share API -------
// Resource: /share
// HTTP Method: POST  > mapped to PutItem
// HTTP Request Body:
// {
//   "routeId":   "md5",
//   "userName": "string - Cognito user name",
//   "userPool":  "string - Cognito user pool"
//	 "shareData": {
//			aiOnly: boolean, (required)
//			projectId: string - "cbp", "gec", etc (required)
//			navMode: string - "curated", "narratives", "compare", "graph" (required)
//			graphTabLineIdArr: - array of objects:  (required if navMode === "graph")
//				{
//					id: "string - md5 hash", (required)
//					perspective: "source" or "reaction"
//					filtersList: array
//					info: "string",
//					name: "string", (required)
//					optimalLag: null or number,
//					parent: undefined or string,
//					predictiveVal: null or number,
//					type: "string",
//				}
//			contentTab: Object  (required if navMode === "compare")
//				{
//					currentTab: {   (required)
//						name: string - ie, "Table", "List", "Expanded", "Map"
//						id: string - ie, "table", "list", "tile", "map"
//					},
//					contentSingleArticleId: "string - md5" or undefined, // For single article share
//					dateEnd: number - utc date number  (required)
//					dateStart: number - utc date number  (required)
//					filters: array of objects  (required - can be empty)
//					 [
//						{
//							active: true, //  (required) always true
//							color: {  (required)
//								colorblind: "colorblindBroken",
//								dark: "#54c4e2",
//								id: "carolina",
//								light: "#54c4e2",
//							},
//							filterType: undefined or string
//							grandparent: undefined or string
//							icon: undefined or React Component
//							id: string   (required)
//							label: undefined ??? not sure what this is for
//							name: string  (required)
//							parent: undefined or string
//							type: undefined or string
//						},
//				}
// 		}
// }

// // Test:
// {
// 	"userName": "Dude",
//   "userPool": "Test User Pool",
// 	// "shareData": {"aiOnly":false,"contentTab":{"filters":"[{\"active\":true,\"color\":{\"id\":\"carolina\",\"dark\":\"#54c4e2\",\"darkChild\":\"#54c4e2\",\"light\":\"#54c4e2\",\"lightChild\":\"#54c4e2\",\"colorblind\":\"colorblindBroken\"},\"id\":\"guatemala\",\"name\":\"Guatemala\",\"parent\":\"location\"},{\"active\":true,\"color\":{\"id\":\"chartruese\",\"dark\":\"#c2eb3c\",\"darkChild\":\"#c2eb3c\",\"light\":\"#c2eb3c\",\"lightChild\":\"#c2eb3c\",\"colorblind\":false},\"id\":\"el salvador\",\"name\":\"El Salvador\",\"parent\":\"location\"}]","dateStart":"1560297600000","dateEnd":"1565568000000","currentTab":false},"graphTabLineIdArr":[],"navMode":"curated","projectId":"cbp","stagingData":null}
// 	// "shareData": '{"aiOnly":false,"contentTab":{"filters":[],"dateStart":"1560297600000","dateEnd":"1565568000000","currentTab":false},"graphTabLineIdArr":[],"navMode":"curated","projectId":"cbp","stagingData":null}'
// 	"shareData": {"aiOnly":false,"contentTab":{"dateStart":"1560297600000","dateEnd":"1565568000000","currentTab":false},"graphTabLineIdArr":[{"id":"trump-elsalvador","filtersList":[],"perspective":"source","name":"El Salvador - Trump","optimalLag":null,"predictiveVal":null,"type":"cbp"}],"navMode":"graph","projectId":"cbp","stagingData":null}
// }

// // Resource: /share/{routeId}
// // HTTP Method: GET > mapped to Query

// // Integration response template map:
// #set($inputRoot = $input.path('$'))
// {
//     "routeId": "$inputRoot.Item.routeId.S",
//     "userName": "$inputRoot.Item.userName.S",
//     "userPool": "$inputRoot.Item.userPool.S",
//     "shareData": "$inputRoot.Item.shareData.S"
// }

// {
// 	"routeId": "{Item={userPool={S=Test User Pool}, userName={S=Test User Name}, routeId={S=bdbfbed5-bace-11e9-ae5b-0f9aca61697e}, shareData={S={text=Test Share data}}}}",
// }

// bad: Endpoint response body before transformations: {"__type":"com.amazon.coral.service#SerializationException"}
// good: Endpoint response body before transformations: {}

// {
// 	"routeId": "$context.requestId",
// 	"errorMessage": "$context.error.message",
// 	"errorType": "$context.error.responseType",
// 	"errorString": "$context.error.messageString",
// 	"errorValidationString": "$context.error.validationErrorString"
// }




// Entity View - EntityData
let entityDataAbortController = {};
const abortEntityDataFetch = () => {
	if (entityDataAbortController) {
		entityDataAbortController.abort();
	}
}

const doFetchEntityData = (parameters) => {
	const { dispatch, getState, entity } = parameters;
	const { aiOnly } = getState().commonUI;
	const { entityDataFetchCount } = getState().entityView;
	const { api, userEmail, userData, userName, authToken } = getState().login;
	const userPool = userData && userData.pool && userData.pool.userPoolId;
	const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);

	// forcibly refresh tokens
	Auth.currentSession().catch(() => dispatchTokenFailure());

	// Fetch the filters and process response
	return fetch(`${api.singleArticle}?id=${entity.id}&index=${entity.index}&ai=${aiOnly}&getDoc=unsafe&email=${userEmail}`, {
		method: "GET",
		signal: entityDataAbortController.signal,
		mode: "cors",
		headers: {
			"Content-Type": "application/json",
			Authorization: idToken,
		},
	})
	.then((response) => {
		if (!response.ok) {
			throw new Error(SERVER_ERROR);
		}
		return response.json();
	})
	.then((json) => {
		const transformedEntity = entityTransformer(json);
		dispatch({ type: ENTITY_VIEW_RECEIVE_ENTITY_DATA, data: transformedEntity });
	})
	.catch((error) => {
		if (error.name === 'AbortError') {
			// No action needed
		}
		else if (entityDataFetchCount >= FETCH_RETRY_MAX) {
			console.error(error);
			dispatch({type: ENTITY_VIEW_RECEIVE_ENTITY_DATA_ERROR});
		}
		else {
			console.warn(`${error} - Retry attempt ${entityDataFetchCount + 1}...`);
			dispatch({type: ENTITY_VIEW_RECEIVE_ENTITY_DATA_RETRY});
			doFetchEntityData(parameters);
		}
	})
};

export const fetchEntityData = (entity) => {
	return (dispatch, getState) => {
		const { entityDataLoading } = getState().entityView;
		if (entityDataLoading) {
			abortEntityDataFetch();
		}
		entityDataAbortController = new AbortController();
		dispatch({type: ENTITY_VIEW_FETCH_ENTITY_DATA, entity});
		doFetchEntityData({dispatch, getState, entity});
	};
};

// Entity View - Affiliations Graph Data
let entityGraphAbortController = {};
const abortEntityGraphFetch = () => {
	if (entityGraphAbortController) {
		entityGraphAbortController.abort();
	}
}

const doFetchEntityGraph = (parameters) => {
	const { dispatch, getState, entityId, depth } = parameters;
	const { graphDataFetchCount } = getState().entityView;
	const { api, userData, userName, authToken } = getState().login;
	const userPool = userData && userData.pool && userData.pool.userPoolId;
	const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);

	// forcibly refresh tokens
	Auth.currentSession().catch(() => dispatchTokenFailure());

	// Fetch the filters and process response
	return fetch(`${api.entityGraph}`, {
		method: "POST",
		signal: entityGraphAbortController.signal,
		mode: "cors",
		body: JSON.stringify({
			project: api.key,
			userName,
			userPool,
			user: `${userName}_${userPool}`,
			id: entityId,
			recursionLimit: depth,
			edgeLimit: 9999,
		}),
		headers: {
			"Content-Type": "application/json",
			Authorization: idToken,
		},
	})
	.then((response) => {
		if (!response.ok) {
			throw new Error(SERVER_ERROR);
		}
		return response.json()
	})
	.then((json) => {
		const {edgeMap, nodeMap, graphData} = graphTransformer(json, entityId);
		dispatch({ type: ENTITY_VIEW_RECEIVE_GRAPH_DATA, data: graphData, edgeMap, nodeMap });
	})
	.catch((error) => {
		if (error.name === 'AbortError') {
			// No action needed
		}
		else if (graphDataFetchCount >= FETCH_RETRY_MAX) {
			console.error(error);
			dispatch({type: ENTITY_VIEW_RECEIVE_GRAPH_DATA_ERROR});
		}
		else {
			console.warn(`${error} - Retry attempt ${graphDataFetchCount + 1}...`);
			dispatch({type: ENTITY_VIEW_RECEIVE_GRAPH_DATA_RETRY});
			doFetchEntityGraph(parameters);
		}
	})
};

export const fetchEntityGraph = (entityId, depth) => {
	return (dispatch, getState) => {
		const { graphDataLoading } = getState().entityView;
		if (graphDataLoading) {
			abortEntityGraphFetch();
		}
		entityGraphAbortController = new AbortController();
		dispatch({type: ENTITY_VIEW_FETCH_GRAPH_DATA});
		doFetchEntityGraph({dispatch, getState, entityId, depth: depth || 3});
	};
};


// Entity View - Expand Affiliations Graph Data
let expandEntityGraphAbortController = {};
const abortExpandEntityGraphFetch = () => {
	if (expandEntityGraphAbortController) {
		expandEntityGraphAbortController.abort();
	}
}

const doExpandEntityGraph = (parameters) => {
	const { dispatch, getState, entityId, depth, nodeCoords } = parameters;
	const { graphExpandFetchCount, graphEdgeMap, graphNodeMap, graphData } = getState().entityView;
	const { api, userData, userName, authToken } = getState().login;
	const userPool = userData && userData.pool && userData.pool.userPoolId;
	const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);

	// forcibly refresh tokens
	Auth.currentSession().catch(() => dispatchTokenFailure());

	// Fetch the filters and process response
	return fetch(`${api.entityGraph}`, {
		method: "POST",
		signal: expandEntityGraphAbortController.signal,
		mode: "cors",
		body: JSON.stringify({
			project: api.key,
			userName,
			userPool,
			user: `${userName}_${userPool}`,
			id: entityId,
			recursionLimit: depth,
			edgeLimit: 9999,
		}),
		headers: {
			"Content-Type": "application/json",
			Authorization: idToken,
		},
	})
	.then((response) => {
		if (!response.ok) {
			throw new Error(SERVER_ERROR);
		}
		return response.json()
	})
	.then((json) => {
		const res = graphExtendTransformer(graphData, graphEdgeMap, graphNodeMap, json, nodeCoords);
		dispatch({ 
			type: ENTITY_VIEW_RECEIVE_EXPAND_GRAPH_DATA, 
			data: res.graphData, 
			edgeMap: res.edgeMap, 
			nodeMap: res.nodeMap,
			isChanged: res.hasChanges,
			numNodesAdded: res.numNodesAdded,
			numEdgesAdded: res.numEdgesAdded,
		});
	})
	.catch((error) => {
		if (error.name === 'AbortError') {
			// No action needed
		}
		else if (graphExpandFetchCount >= FETCH_RETRY_MAX) {
			console.error(error);
			dispatch({type: ENTITY_VIEW_RECEIVE_EXPAND_GRAPH_DATA_ERROR});
		}
		else {
			console.warn(`${error} - Retry attempt ${graphExpandFetchCount + 1}...`);
			dispatch({type: ENTITY_VIEW_RECEIVE_EXPAND_GRAPH_DATA_RETRY});
			doExpandEntityGraph(parameters);
		}
	})
};

export const expandEntityGraph = (entityId, depth, nodeCoords) => {
	return (dispatch, getState) => {
		const { graphExpanding, graphExpandDepth } = getState().entityView;
		if (graphExpanding) {
			abortExpandEntityGraphFetch();
		}
		expandEntityGraphAbortController = new AbortController();
		dispatch({type: ENTITY_VIEW_FETCH_EXPAND_GRAPH_DATA});
		doExpandEntityGraph({dispatch, getState, entityId, depth: depth || graphExpandDepth, nodeCoords});
	};
};


// Fetch Entity View Media Mentions
let entityMediaMentionsAbortController;
const abortEntityMediaMentionsFetch = () => {
	if (entityMediaMentionsAbortController) {
		entityMediaMentionsAbortController.abort();
	}
}

export function doFetchEntityMediaMentions(params) {
	const {
		ascending,
		dispatch,
		entityId,
		getState,
		offset,
		pageLength,
		setup,
		sortBy,
		startDate,
		endDate,
	} = params;
	const { api, authToken, userName } = getState().login;
	const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
	const { 
		mediaMentionsFetchCount, 
		currentZoom, 
		timeSeriesAggregationLevel,
		entityData,
		requestedEntityData,
		contentFilteredByDate,
	} = getState().entityView;

	// forcibly refresh tokens
	Auth.currentSession().catch(() => dispatchTokenFailure())
	entityMediaMentionsAbortController = new AbortController();

	// In the current absence of time controls in the entity view we hack a start date here
	// to avoid the default search behavior of only looking over last 7 days
	// const currDate = moment().utcOffset(0);
	// const startDate = currDate.clone().subtract(5, 'years');
	// const startDateNum = startDate.hours(0).minutes(0).seconds(0).milliseconds(0).valueOf();

	return (
		fetch(`${api.getMediaContent}`, {
			method: "POST",
			signal: entityMediaMentionsAbortController.signal,
			mode: "cors",
			body: JSON.stringify({
				asc: ascending,
				debug: true,
				desc: !ascending,
				endDate: endDate || currentZoom.end || null,
				entitySearch: [entityId || entityData?.id || requestedEntityData?.id],
				// index: searchObj.index,
				language: "All",
				project: api.dataKey,
				query: null,
				queryAdd: [],
				queryExclude: [],
				filters: [],
				sort: [sortBy],
				startDate: startDate 
					|| (contentFilteredByDate 
								? adjustStartDateForAggregation({
										startDate: currentZoom.begin, 
										aggregationLevel: timeSeriesAggregationLevel
									})
								: currentZoom.begin
							)
					|| null,
				translate: false,
				// type: searchObj.type,
				tab: "mediaTab",
				pageLength,
				offset: offset || 0,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error(SERVER_ERROR);
				}
				return response.json()
			})
			.then((json) => {
				dispatch({
					type: ENTITY_VIEW_RECEIVE_MEDIA_MENTIONS,
					articles: json.articles,
					headers: json.headers,
					setup: !!setup,
					// fetchKey: `${searchObj.id}_${searchObj.lang || "noLang"}_${searchObj.locationStr || "noLocation"}_${resBegin}to${resEnd}`,
				})
			})
			.catch((error) => {
				if (error.name === 'AbortError') {
					// No action needed
				}
				else if (mediaMentionsFetchCount >= FETCH_RETRY_MAX) {
					console.error(error);
					dispatch({type: ENTITY_VIEW_RECEIVE_MEDIA_MENTIONS_ERROR});
				}
				else {
					console.warn(`${error} - Retry attempt ${mediaMentionsFetchCount + 1}...`);
					dispatch({type: ENTITY_VIEW_RECEIVE_MEDIA_MENTIONS_RETRY});
					doFetchEntityMediaMentions(params);
				}
			})
	);
}

export function fetchEntityMediaMentions(params) {
	return (dispatch, getState) => {
		const { 
			mediaMentionsLoading, 
			mediaMentionsPageLength,
			mediaMentionsSortAscending,
			mediaMentionsSortType, 
		} = getState().entityView;
		if (mediaMentionsLoading) {
			abortEntityMediaMentionsFetch();
		}
		dispatch({ type: ENTITY_VIEW_FETCH_MEDIA_MENTIONS });
		return doFetchEntityMediaMentions({
			...params, 
			pageLength: mediaMentionsPageLength,
			sortBy: mediaMentionsSortType,
			ascending: mediaMentionsSortAscending,
			dispatch,
			getState
		}) ;
	};
};


// Fetch Entity View Timeseries
let entityTimeSeriesAbortController;
const abortEntityTimeSeriesFetch = () => {
	if (entityTimeSeriesAbortController) {
		entityTimeSeriesAbortController.abort();
	}
}
function doFetchEntityTimeSeries(parameters) {
	const { 
		query, 
		lang, 
		locationStr, 
		entityId,
		dispatch,
		getState,
	} = parameters;

	const { api, userName, authToken } = getState().login;
	const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
	const { 
		activeSearchObj,
		currentZoom, 
		timeSeriesRetryCount,
		mediaMentionsPageLength,
		mediaMentionsSortType,
		mediaMentionsSortAscending,
	} = getState().entityView;
	// const formattedFilters = [{ entities: outletFilters.length > 0 ? outletFilters : [] }, { keywords: [query] }];
	// const formattedFilters = formatHierarchyFiltersForPost(filters);
	// const queryAdds = formatQueryAddsForPost(currentFiltersList);
	const queryToSend = (query && query.length > 0) ? query : undefined;

	const params = JSON.stringify({
		endDate: currentZoom.end || null,
		entitySearch: [entityId],
		project: api.key,
		query: queryToSend,
		startDate: currentZoom.begin || null,
		tab: "mediaTab",
	});

	const id = activeSearchObj?.id;
	const name = activeSearchObj?.name;

	// forcibly refresh tokens
	Auth.currentSession().catch(() => dispatchTokenFailure())
	
	entityTimeSeriesAbortController = new AbortController();

	// Send the request and process response
	return (
		fetch(`${api.getMediaTimeseries}`, {
			method: "POST",
			signal: entityTimeSeriesAbortController.signal,
			mode: "cors",
			body: params,
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
		.then((response) => {
			if (!response.ok) {
				throw new Error(SERVER_ERROR);
			}
			return response.json()
		})
		.then((json) => {
			// console.log("getMediaTimeseries - response - ", json);
			json.id = json.id || id;
			json.name = json.name || name;

			const lines = assignStaticColor({ list: [json], colors });
			const keys = Object.keys(lines[0].timeseries);
			const rangeStart = Number(keys[0]);
			const rangeEnd = Number(keys[keys.length - 1]);
			dispatch({
				type: ENTITY_VIEW_RECEIVE_TIME_SERIES,
				lines,
				query,
				fetchKey: `${id}_${lang || "noLang"}_${locationStr || "noLocation"}_${rangeStart}to${rangeEnd}`,
			});
			dispatch(fetchEntityMediaMentions({
				ascending: mediaMentionsSortAscending,
				begin: currentZoom.begin ,
				end: currentZoom.end,
				entityId: entityId,
				query: activeSearchObj && activeSearchObj.query,
				searchObj: activeSearchObj,
				sortBy: mediaMentionsSortType,
				pageLength: mediaMentionsPageLength,
				offset: 0,
			}))
		})
		.catch((error, json) => {
			if (error.name === 'AbortError') {
				// No action needed
			}
			else if (timeSeriesRetryCount >= FETCH_RETRY_MAX) {
				console.error(error);
				dispatch({type: ENTITY_VIEW_RECEIVE_TIME_SERIES_ERROR,	data: json});
			}
			else {
				console.warn(`${error} - Retry attempt ${timeSeriesRetryCount + 1}...`);
				dispatch({type: ENTITY_VIEW_RECEIVE_TIME_SERIES_RETRY});
				dispatch(doFetchEntityTimeSeries(parameters));
			}
		})
	);
};

export function fetchEntityTimeSeries(params) {
	return (dispatch, getState) => {
		const { timeSeriesLoading } = getState().entityView;
		// Abort any outstanding requests
		if (timeSeriesLoading) {
			abortEntityTimeSeriesFetch();
		}
		dispatch({type: ENTITY_VIEW_FETCH_TIME_SERIES});
		return doFetchEntityTimeSeries({
			...params, 
			dispatch,
			getState
		}) ;
	};
};


let queryExpansionAbortController;
const abortQueryExpansion = () => {
	if (queryExpansionAbortController) {
		queryExpansionAbortController.abort();
	}
}
const doFetchQueryExpansion = (params) => {
	const { dispatch, getState, queryString, actionId, alreadyLoading, loadingActionId, languages, translationEnabled } = params;
	const { api, userName, authToken } = getState().login;
	const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
	const errorStr = "<unable to expand query>"

	// Abort any outstanding requests and setup the abort controller
	if (alreadyLoading) {
		abortQueryExpansion();
	}
	queryExpansionAbortController = new AbortController();

	// Cant expand an empty query so just set it to an empty string instead
	if (!queryString || queryString.trim().length === 0) {
		return dispatch({type: actionId, value: ""});
	}

	// forcibly refresh tokens
	Auth.currentSession().catch(() => dispatchTokenFailure())

	// Set the loading state of the expanded query
	dispatch({type: loadingActionId});

	// Retreive the expanded query from the API
	return fetch(`${api.queryExpansion}`, {
		method: "POST",
		mode: "cors",
		signal: queryExpansionAbortController.signal,
		body: JSON.stringify({
			query: queryString,
			translate_to: !translationEnabled ? [] : languages,
		}),
		headers: {
			"Content-Type": "application/json",
			Authorization: idToken,
		},
	})
	.then((response) => response.json())
	.then((json) => {
		dispatch({type: actionId, value: json.translated_query, error: json.error });
	})
	.catch((error, json) => {
		if (error.name === 'AbortError') {
			// No action needed
		}
		else {
			console.error(error, json);
			dispatch({type: actionId, error: errorStr});
		}
	})
};


let queryExpandDebounceTimer;
const queryExpandDebouneDelay = 1000;
export const fetchQueryExpansion = (params) => {
	return (dispatch, getState) => {
		clearTimeout(queryExpandDebounceTimer);
		if (params.disableDebounce) {
			doFetchQueryExpansion({...params, dispatch, getState});
		}
		else {
			queryExpandDebounceTimer = setTimeout(() => { 
				doFetchQueryExpansion({...params, dispatch, getState});
			}, queryExpandDebouneDelay);
		}
	}
}